import React, { useState, useRef, useEffect, useCallback } from 'react';
import { FaArrowLeft, FaMapMarkerAlt, FaHeart, FaShare, FaWhatsapp, FaRuler, FaUser, FaBed, FaBath, FaParking, FaWineBottle, FaHome, FaWifi, FaTv, FaWater, FaUtensils, FaCar, FaArrowsAltV, FaSnowflake, FaSmokingBan, FaBellSlash, FaTrash } from 'react-icons/fa';
import ReactSelect from '../../../components/Selects/AutoCloseSelect';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import ProgressSteps from './ProgressSteps';

import { jwtDecode } from 'jwt-decode';

// Toast estilizado
const Toast = styled.div`
  position: fixed;
  bottom: 32px;
  right: 32px;
  background: ${props => props.type === 'success' ? '#22c55e' : '#ef4444'};
  color: white;
  padding: 18px 32px;
  border-radius: 10px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.13);
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  gap: 16px;
  z-index: 9999;
  min-width: 280px;
  animation: fadeIn 0.3s;
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(30px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

const SideAction = styled.button`
  width: 100%;
  background: #fff;
  border: 1px solid #E6D5C5;
  color: #BA824F;
  padding: 12px;
  border-radius: 12px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

const SideButton = styled.button`
  width: 100%;
  background: #fff;
  border: 1px solid #e2e8f0;
  color: #1f2937;
  padding: 12px;
  border-radius: 12px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

const HostCard = styled.div`
  background: #fff;
  border: 1px solid #eef2f7;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  padding: 18px;
  margin-top: 14px;
  display: grid;
  justify-items: center;
  text-align: center;

  .avatar {
    width: 88px;
    height: 88px;
    border-radius: 50%;
    overflow: hidden;
    border: 3px solid #BA824F;
    margin-bottom: 10px;
  }
  .name { font-weight: 800; font-size: 1.1rem; color: #111827; }
  .role { color: #6b7280; font-size: .9rem; margin-top: 2px; }
  .line { color: #374151; font-size: .93rem; margin-top: 4px; }
  .rating { margin-top: 8px; color: #f59e0b; font-weight: 700; }
`;


const PageContainer = styled.div`
  min-height: calc(100vh - 80px);
  padding: 40px 20px;
`;

const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 320px 1fr;
  gap: 24px;

  @media (max-width: 1400px) {
    grid-template-columns: 280px 1fr;
  }

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

const Sidebar = styled.div`
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  height: fit-content;
  position: sticky;
  top: 24px;
`;

// Botão "olho" para pré-visualização
const EyeButton = styled.button`
  border: none;
  background: #fff;
  color: #34574A;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  cursor: pointer;
  transition: transform .15s ease, box-shadow .15s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(0,0,0,0.2);
  }
`;

// Modal de pré-visualização
const PreviewModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
`;

const PreviewModalBox = styled.div`
  width: 90vw;
  max-height: 90vh;
  overflow: auto;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 12px 40px rgba(0,0,0,0.25);
`;

const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #edf2f7;
  h3 { margin: 0; color: #34574A; }
`;

const CloseModal = styled.button`
  border: none;
  background: #34574A;
  color: #fff;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
`;

const LightboxClose = styled.button`
  position: absolute;
  top: 18px;
  right: 18px;
  background: rgba(0,0,0,0.5);
  color: #fff;
  border: 2px solid #fff;
  border-radius: 999px;
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s, transform 0.15s;

  &:hover {
    background: rgba(255,255,255,0.12);
    transform: scale(1.03);
  }
`;

// Lightbox de fotos
const LightboxOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 11000;
`;

const LightboxImage = styled.div`
  width: min(1200px, 95vw);
  height: min(80vh, 900px);
  background: ${p => p.$image ? `url(${p.$image}) center/contain no-repeat` : 'transparent'};
`;

const LightboxNav = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${p => p.$left ? 'left: 24px;' : 'right: 24px;'}
  background: rgba(255,255,255,0.15);
  color: #fff;
  border: 1px solid rgba(255,255,255,0.25);
  padding: 10px 14px;
  border-radius: 8px;
  cursor: pointer;
`;

// Estilos internos do modal de preview
const ModalBody = styled.div`
  padding: 20px;
`;

const ModalGrid = styled.div`
  display: grid;
  grid-template-columns: 9fr 3fr; /* 9 x 3 proporção desejada */
  gap: 24px;
  align-items: start;
`;

const Gallery = styled.div``;

const MainPhoto = styled.div`
  width: 100%;
  padding-top: 56%;
  border-radius: 12px;
  background: ${props => props.$image ? `url(${props.$image}) center/cover no-repeat` : '#edf2f7'};
`;

const Thumbs = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  gap: 10px;
  margin-top: 12px;
`;

const Thumb = styled.button`
  border: 2px solid ${p => p.$active ? '#34574A' : '#e2e8f0'};
  border-radius: 8px;
  aspect-ratio: 1;
  background: ${p => p.$image ? `url(${p.$image}) center/cover no-repeat` : '#edf2f7'};
  cursor: pointer;
`;

const SideInfo = styled.div``;

const Price = styled.div`
  font-size: 1.25rem;
  color: #34574A;
  font-weight: 600;
  margin: 8px 0 16px;
`;

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px 16px;
  margin-bottom: 16px;
`;

const InfoItem = styled.div`
  .label { font-size: 12px; color: #718096; }
  .value { font-size: 14px; color: #2d3748; font-weight: 600; }
`;

const Section = styled.div`
  margin-top: 16px;
`;

const ModalSectionTitle = styled.h4`
  margin: 0 0 8px 0;
  color: #2d3748;
`;

// Hero grid ao estilo da página Property (1 grande + 4 thumbs)
const HeroGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr; /* 6 / 6 */
  grid-template-rows: repeat(2, 260px);
  gap: 8px;
  margin-bottom: 20px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    grid-template-rows: 220px 120px 120px 120px 120px;
  }
`;

const HeroMain = styled.div`
  grid-row: 1 / span 2;
  border-radius: 0;
  background: ${p => p.$image ? `url(${p.$image}) center/cover no-repeat` : '#edf2f7'};
`;

const HeroThumb = styled.div`
  border-radius: 0;
  background: ${p => p.$image ? `url(${p.$image}) center/cover no-repeat` : '#edf2f7'};
  position: relative;
`;

// Container para as 4 thumbs (2 colunas x 2 linhas) na coluna da direita
const RightMosaic = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr; /* 2 colunas */
  grid-template-rows: 1fr 1fr;   /* 2 linhas */
  gap: 8px;
  grid-row: 1 / span 2;          /* ocupa as 2 linhas do HeroGrid */
  height: 100%;
  min-height: 0;
`;

const ViewAllButton = styled.button`
  position: absolute;
  right: 8px;
  bottom: 8px;
  background: #2F855A;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 8px 12px;
  cursor: pointer;
  font-weight: 600;
`;

// Card de reserva à direita
const BookingBox = styled.div`
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.07);
  padding: 16px;
  position: sticky;
  top: 16px;
  height: fit-content;
  margin-top: 14px; /* gap para não colar no topo */
`;

// Limite para conteúdo abaixo das fotos (80% da largura do modal)
const ContentContainer = styled.div`
  width: 80%;
  margin: 0 auto;
`;

// Barra de ações abaixo do hero (como no site)
const ActionBar = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: start;
  gap: 16px;
  padding: 8px 0 18px 0;
  border-bottom: 1px solid #edf2f7;
`;

const LeftGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const TopRow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 12px;
`;

const BackLink = styled.button`
  border: none;
  background: none;
  color: #6b7280;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  font-size: 0.9rem;
`;

const Badge = styled.span`
  background: #C0864A; /* marrom dourado do mock */
  color: #fff;
  border-radius: 999px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 700;
`;

const TitleStatus = styled.div`
  font-size: 1.35rem;
  font-weight: 800;
  color: #2d3748;
`;

const LocationText = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #718096;
  font-size: 0.95rem;
  margin-top: 2px;
`;

const RightGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const GhostButton = styled.button`
  background: white;
  border: 1px solid #E6D5C5; /* tom bege do mock */
  color: #4a5568;
  border-radius: 10px;
  padding: 8px 12px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 0 0 1px rgba(0,0,0,0.02) inset;
  &:hover { background: #FFFBF7; }
`;

// Título de seção (menor) + Card de seção
const PillTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 800;
  color: #2d3748;
  margin: 0 0 12px 0;
`;

const SectionCard = styled.div`
  background: #fff;
  border: 1px solid #f1f5f9;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  padding: 20px;
  margin: 22px 0 14px 0;
`;

const FactsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 14px;
`;

const FactItem = styled.div`
  display: grid;
  grid-template-columns: 24px 1fr;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
  .label { font-size: 11px; color: #64748b; letter-spacing: .02em; }
  .value { font-size: 14px; font-weight: 700; color: #111827; }
`;

const DetailsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 16px;
`;

const DetailItem = styled.div`
  display: grid;
  grid-template-columns: 24px 1fr;
  align-items: center;
  gap: 10px;
  .detail-label { font-size: 12px; color: #64748b; }
  .detail-value { font-size: 14px; font-weight: 700; color: #111827; }
`;

// Lista de comodidades (preview) em duas colunas com ícones
const AmenitiesList = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 24px;
`;
const AmenityRow = styled.div`
  display: grid;
  grid-template-columns: 24px 1fr;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: ${p => p.$disabled ? '#9ca3af' : '#111827'};
  text-decoration: ${p => p.$disabled ? 'line-through' : 'none'};
  .icon { color: ${p => p.$disabled ? '#cbd5e1' : '#64748b'}; }
`;

const Progress = styled.div`
  padding: 24px;
  border-bottom: 1px solid #edf2f7;

  h2 {
    font-size: 1rem;
    color: #2d3748;
    margin-bottom: 16px;
  }

  .progress-bar {
    width: 100%;
    height: 8px;
    background: #edf2f7;
    border-radius: 4px;
    overflow: hidden;

    .fill {
      height: 100%;
      background: #34574A;
      width: ${props => props.$progress}%;
      transition: width 0.3s ease;
    }
  }

  .steps-completed {
    font-size: 0.875rem;
    color: #718096;
    margin-top: 8px;
  }
`;

const Steps = styled.div`
  padding: 16px 0;
`;

const Step = styled.button`
  width: 100%;
  padding: 16px 24px;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
  color: ${props => props.$active ? '#34574A' : '#4a5568'};
  transition: all 0.3s ease;

  &:hover {
    background: ${props => props.$active ? '#f0fff4' : '#f7fafc'};
  }

  .number {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.875rem;
    font-weight: 500;
    background: ${props => props.$active ? '#34574A' : '#edf2f7'};
    color: ${props => props.$active ? 'white' : '#4a5568'};
  }

  .text {
    font-size: 0.875rem;
    font-weight: 500;
  }

  ${props => props.$completed && `
    .number {
      background: #34574A;
      color: white;
    }
  `}
`;

const MainContent = styled.div`
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  background: #34574A;
  padding: 32px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Title = styled.h1`
  font-size: 1.75rem;
  margin: 0;
  color: white;
`;

const Subtitle = styled.p`
  margin: 8px 0 0;
  opacity: 0.8;
  font-size: 1rem;
`;

const StepContent = styled.div`
  padding: 32px;
`;

const Preview = styled.div`
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  height: fit-content;
  overflow: hidden;
  margin-top: 24px;
`;

const PreviewHeader = styled.div`
  padding: 24px;
  border-bottom: 1px solid #edf2f7;

  h2 {
    font-size: 1rem;
    color: #2d3748;
    margin: 0;
  }
`;

const PreviewContent = styled.div`
  padding: 24px;
`;

const PreviewImage = styled.div`
  width: 100%;
  padding-top: 66.67%;
  background: ${props => props.$image ? `url(${props.$image}) center/cover no-repeat` : '#edf2f7'};
  border-radius: 8px;
  margin-bottom: 24px;
`;

const PreviewInfo = styled.div`
  h3 {
    font-size: 1.25rem;
    color: #2d3748;
    margin: 0 0 8px 0;
  }

  .price {
    font-size: 1.5rem;
    color: #34574A;
    font-weight: 500;
    margin-bottom: 16px;
  }

  .details {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    margin-bottom: 24px;

    .item {
      .label {
        font-size: 0.75rem;
        color: #718096;
        margin-bottom: 4px;
      }
      .value {
        font-size: 0.875rem;
        color: #2d3748;
        font-weight: 500;
      }
    }
  }

  .description {
    font-size: 0.875rem;
    color: #4a5568;
    line-height: 1.5;
  }
`;

const NavigationButtons = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 24px 32px;
  border-top: 1px solid #edf2f7;
`;

const Button = styled.button`
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #34574A;
  border: none;
  color: white;

  &:hover {
    background: #2a4539;
  }

  &.secondary {
    background: white;
    border: 2px solid #e2e8f0;
    color: #4a5568;

    &:hover {
      background: #f8fafc;
      border-color: #cbd5e0;
    }
  }

  &.danger {
    background: white;
    border: 2px solid #fca5a5;
    color: #b91c1c;

    &:hover {
      background: #fef2f2;
      border-color: #f87171;
      color: #991b1b;
    }
  }

  &.primary {
    background: #34574A;
    border: none;
    color: white;

    &:hover {
      background: #2a4539;
    }
  }
`;

const FormSection = styled.div`
  margin-bottom: 32px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const SectionTitle = styled.h3`
  font-size: 1rem;
  color: #2d3748;
  font-weight: 600;
  line-height: 1.3;
  margin: 24px 0 18px 0;
  padding-bottom: 4px;
  letter-spacing: 0.01em;
  background: none;
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }

  &.three-columns {
    grid-template-columns: repeat(3, 1fr);

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }
`;

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px; // Added consistent spacing between inputs

  &.full-width {
    grid-column: 1 / -1;
  }
`;

const Label = styled.label`
  font-size: 0.875rem;
  font-weight: 500;
  color: #4a5568;

  &.required::after {
    content: ' *';
    color: #e53e3e;
  }
`;

const Input = styled.input`
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s ease;

  &:focus {
    border-color: #34574A;
    outline: none;
    box-shadow: 0 0 0 3px rgba(52, 87, 74, 0.1);
  }

  &::placeholder {
    color: #a0aec0;
  }
`;

const MonetaryInput = styled(Input)`
  /* Chrome, Safari, Edge, Opera */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  -moz-appearance: textfield;
`;

const NumericInput = styled(Input)`
  /* Chrome, Safari, Edge, Opera */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  -moz-appearance: textfield;
`;

const Select = styled.select`
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s ease;
  background: white;
  color: #2d3748;
`;

const RadioGroup = styled.div`
  display: flex;
  gap: 24px;
  margin-top: 8px;
`;

const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  color: #4a5568;
`;

const RadioInput = styled.input`
  cursor: pointer;
  width: 18px;
  height: 18px;
  accent-color: #34574A;
`;

const TextArea = styled.textarea`
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  resize: vertical;
  min-height: 120px;
  transition: all 0.3s ease;

  &:focus {
    border-color: #34574A;
    outline: none;
    box-shadow: 0 0 0 3px rgba(52, 87, 74, 0.1);
  }

  &::placeholder {
    color: #a0aec0;
  }
`;

const PhotosGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 16px;
`;

const PhotoUploadBox = styled.div`
  border: 2px dashed #e2e8f0;
  border-radius: 8px;
  aspect-ratio: 1;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${props => props.$preview ? `url(${props.$preview}) center/cover no-repeat` : 'white'};

  &:hover {
    border-color: #34574A;
    background-color: ${props => props.$preview ? 'initial' : '#f7fafc'};
  }

  input {
    display: none;
  }

  .icon {
    font-size: 1.5rem;
    color: #a0aec0;
    margin-bottom: 8px;
  }

  .text {
    font-size: 0.75rem;
    color: #4a5568;
    text-align: center;
  }

  ${props => props.$preview && `
    .icon, .text {
      display: none;
    }
  `}

  .remove {
    position: absolute;
    top: 8px;
    right: 8px;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    border: none;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    opacity: ${props => props.$preview ? 1 : 0};
    transition: opacity 0.3s ease;

    &:hover {
      background: rgba(0, 0, 0, 0.7);
    }
  }

  &.main-photo {
    grid-column: span 2;
    grid-row: span 2;
  }
`;

const AmenitiesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
`;

const ExtrasList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const ExtraItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  background: white;
  transition: all 0.3s ease;

  &:hover {
    border-color: #34574A;
    background: #f7fafc;
  }

  .text {
    font-size: 0.875rem;
    color: #4a5568;
    flex: 1;
  }
`;

const RemoveButton = styled.button`
  background: transparent;
  border: 1px solid #e5e7eb;
  color: #b91c1c;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  margin-left: 12px;

  &:hover {
    background: #fef2f2;
    border-color: #fecdd3;
    color: #991b1b;
  }
`;

const AddExtrasRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-end;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const AddButton = styled.button`
  padding: 12px 24px;
  background: #34574A;
  border: none;
  border-radius: 8px;
  color: white;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;

  &:hover {
    background: #2a4539;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const AmenitiesToolbar = styled.div`
  display: flex;
  gap: 8px;
  margin: 8px 0 12px;
  flex-wrap: wrap;
`;

const ToolbarButton = styled.button`
  padding: 10px 14px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  background: #f3f4f6;
  color: #111827;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #e5e7eb;
    border-color: #d1d5db;
  }
`;

const Amenity = styled.label`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    border-color: #34574A;
    background: #f7fafc;
  }

  input {
    width: 16px;
    height: 16px;
  }

  .icon {
    width: 24px;
    height: 24px;
    color: #4a5568;
  }

  .text {
    font-size: 0.875rem;
    color: #4a5568;
  }

  ${props => props.$checked && `
    border-color: #34574A;
    background: #f0fff4;
  `}
`;

// ATENÇÃO: Defina sua chave da API do Google Places aqui ou em um .env seguro
const GOOGLE_API_KEY = import.meta.env.VITE_GOOGLE_API_KEY;

const INITIAL_FORM_DATA = {
  tituloIMOVEL: '',
  slugIMOVEL: '',
  tipoIMOVEL: '',
  categoriaIMOVEL: '',
  pacoteIMOVEL: '',
  planoIMOVEL: '',
  moedaIMOVEL: 'EUR',
  descricaoIMOVEL: '',
  regrasadicionaisIMOVEL: '',
  valorIMOVEL: '',
  labelvalorIMOVEL: '',
  imobiliariaIMOVEL: '',
  agenteIMOVEL: '',
  clienteIMOVEL: '',
  idIMOVEL: '',
  comodidadesIMOVEL: [],
  comodidadesExtras: [],
  fotos: [],
  enderecoIMOVEL: '',
  numeroIMOVEL: '',
  zipcodeIMOVEL: '',
  cityIMOVEL: '',
  stateIMOVEL: '',
  paisIMOVEL: '',
  latitudeIMOVEL: '',
  longitudeIMOVEL: '',
  permanenciaminimaIMOVEL: '',
  permanenciamaximaIMOVEL: '',
  checkinIMOVEL: '',
  checkoutIMOVEL: '',
  ativoIMOVEL: '',
  exibirPreco: true,
  instantBooking: false,
  cancellationPolicy: '',
  casadebanhoIMOVEL: '',
  solteirocamasIMOVEL: '',
  casalcamasIMOVEL: '',
  quartosIMOVEL: '',
  vagasgaragemIMOVEL: '',
  // Additional property characteristics
  qtdpessoasIMOVEL: '',
  tipometragemIMOVEL: '',
  metragemIMOVEL: '',
  andaresIMOVEL: '',
  anoconstrucaoIMOVEL: '',
  situacaoIMOVEL: '',
  posicaosolarIMOVEL: '',
  // Media fields
  videoIMOVEL: '',
  '360IMOVEL': '',
  // Boolean amenity fields
  fumarIMOVEL: false,
  quadraesportivaIMOVEL: false,
  arcondicionadoIMOVEL: false,
  coberturaIMOVEL: false,
  petsIMOVEL: false,
  wifiIMOVEL: false,
  lavanderiaIMOVEL: false,
  closetIMOVEL: false,
  elevadorIMOVEL: false,
  festaIMOVEL: false,
  poraoIMOVEL: false,
  portariaIMOVEL: false,
  proximoaometroIMOVEL: false,
  academiaIMOVEL: false,
  salaodejogosIMOVEL: false,
  tvIMOVEL: false,
  aquecimentoIMOVEL: false,
  cozinhaIMOVEL: false,
  maquinadelavarIMOVEL: false,
  estacionamentoIMOVEL: false,
  piscinaIMOVEL: false,
  varandaIMOVEL: false,
  churrasqueiraIMOVEL: false,
  seguranca24hIMOVEL: false,
  vistadomarIMOVEL: false,
  mobiliadoIMOVEL: false,
  acesso_praiaIMOVEL: false,
  refrigeradorIMOVEL: false,
  detectorfumacaIMOVEL: false,
  alarmemonoxidoIMOVEL: false,
  // Holiday rental specific fields
  limpezaCobrada: false,
  valorLimpeza: '',
  taxaTurismoCobrada: false,
  valorTaxaTurismoAdulto: '',
  valorTaxaTurismoCrianca: '',
  idadeMaximaCrianca: ''
};

const NewProperty = () => {
  const [toast, setToast] = React.useState({ open: false, message: '', type: 'success' });
  const skipDraftPersistRef = React.useRef(false);
  const [draftRestored, setDraftRestored] = React.useState(false);
  const showToast = (message, type = 'success', duration = 4000) => {
    setToast({ open: true, message, type });
    setTimeout(() => setToast({ open: false, message: '', type }), duration);
  };

  // Helper function to get user ID from JWT token or user object
  const getUserId = () => {
    try {
      const token = localStorage.getItem('auth_token');
      console.log('🔍 [USER ID DEBUG] Token encontrado:', !!token);
      if (token) {
        const decoded = jwtDecode(token);
        console.log('🔍 [USER ID DEBUG] Token decodificado:', decoded);
        const userId = decoded.codigo || decoded.sub || decoded.userId || decoded.id || decoded.user_id;
        console.log('🔍 [USER ID DEBUG] userId do token:', userId);
        return userId;
      }

      const userStr = localStorage.getItem('user');
      console.log('🔍 [USER ID DEBUG] User string encontrada:', !!userStr);
      if (userStr) {
        const user = JSON.parse(userStr);
        console.log('🔍 [USER ID DEBUG] User object:', user);
        const userId = user.codigoUSUARIO || user.codigo || user.id || user.userId || user.user_id;
        console.log('🔍 [USER ID DEBUG] userId do user object:', userId);
        return userId;
      }
    } catch (error) {
      console.warn('[NewListing] Error getting user ID:', error);
    }
    console.log('🔍 [USER ID DEBUG] Nenhum userId encontrado, retornando null');
    return null;
  };

  const [userId, setUserId] = useState(null);

  // Carrega userId quando o componente montar
  React.useEffect(() => {
    const id = getUserId();
    console.log('🔍 [USER ID DEBUG] userId carregado no useEffect:', id);
    setUserId(id);
  }, []);

  const handleCancel = () => {
    (async () => {
      try {
        const { default: Swal } = await import('sweetalert2');
        const result = await Swal.fire({
          icon: 'warning',
          title: 'Cancelar anúncio',
          text: 'Deseja cancelar e apagar todos os dados deste rascunho?',
          showCancelButton: true,
          confirmButtonText: 'Sim, descartar rascunho',
          cancelButtonText: 'Voltar',
          confirmButtonColor: '#dc2626',
          cancelButtonColor: '#4a5568',
          reverseButtons: true,
        });
        if (result.isConfirmed) {
          skipDraftPersistRef.current = true;
          localStorage.removeItem(`newListingDraft:${userId}`);
      localStorage.removeItem(`newListingDraft:${userId}:fotos`);
          resetNewListingForm();
          navigate('/dashboard/listings');
        }
      } catch (e) {
        if (window.confirm('Deseja cancelar e apagar todos os dados deste rascunho?')) {
          skipDraftPersistRef.current = true;
          localStorage.removeItem(`newListingDraft:${userId}`);
      localStorage.removeItem(`newListingDraft:${userId}:fotos`);
          resetNewListingForm();
          navigate('/dashboard/listings');
        }
      }
    })();
  };
  const navigate = useNavigate();

  const clearDraftStorage = useCallback(() => {
    try {
      localStorage.removeItem(`newListingDraft:${userId}`);
      localStorage.removeItem(`newListingDraft:${userId}:fotos`);
    } catch {
      // Ignore localStorage cleanup errors
      }
  }, [userId]);

  const [currentStep, setCurrentStep] = useState(1);
  const [completedSteps, setCompletedSteps] = useState([]); // Controla etapas concluídas
  const [role, setRole] = useState('PARTICULAR');
  const [currentUser, setCurrentUser] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [amenitiesExpanded, setAmenitiesExpanded] = useState(false);
  const [extrasExpanded, setExtrasExpanded] = useState(false);
  const [descriptionExpanded, setDescriptionExpanded] = useState(false);
  const [tipoIncompativel, setTipoIncompativel] = useState(false);
  const [planoBloqueado, setPlanoBloqueado] = useState(false);
  const [motivoBloqueio, setMotivoBloqueio] = useState('');
  const [anunciosCount, setAnunciosCount] = useState({});
  const [anunciosCountPlano, setAnunciosCountPlano] = useState({});

  // Busca contagem real de anúncios por pacote/plano (compatível com imóveis antigos)
  const fetchAnunciosCount = useCallback(async () => {
    try {
      const token = localStorage.getItem('auth_token');
      const res = await fetch(`${import.meta.env.VITE_URL_API}/imoveis/me`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'accept': 'application/json'
        }
      });
      if (res.ok) {
        const data = await res.json();
        const lista = data?.imoveis || [];
        const porPacote = {};
        const porPlano = {};
        lista.forEach(anuncio => {
          if (anuncio.pacoteIMOVEL) {
            const pacoteKey = String(anuncio.pacoteIMOVEL);
            porPacote[pacoteKey] = (porPacote[pacoteKey] || 0) + 1;
          } else if (anuncio.planoIMOVEL) {
            // Imóveis antigos podem estar vinculados só pelo plano
            const planoKey = String(anuncio.planoIMOVEL);
            porPlano[planoKey] = (porPlano[planoKey] || 0) + 1;
          }
        });
        setAnunciosCount(porPacote);
        setAnunciosCountPlano(porPlano);
        console.log('[NewListing] Contagem por pacote:', porPacote);
        console.log('[NewListing] Contagem por plano:', porPlano);
      }
    } catch (error) {
      console.error('Erro ao buscar contagem de anúncios:', error);
    }
  }, []);

  // Normaliza a contagem de um pacote: prioriza vínculo direto, depois plano para imóveis antigos
  const getPacoteContagem = useCallback((pkg) => {
    const limite = pkg?.limite ?? pkg?.plano?.quantidadePLANO ?? pkg?.quantidadeCHECKOUT;
    let utilizados = pkg?.utilizados;
    let disponiveis = pkg?.disponiveis;

    if (typeof utilizados === 'undefined' || utilizados === null) {
      const pacoteId = String(pkg?.codigoCHECKOUT);
      const planoId = String(pkg?.plano?.codigoPLANO);
      utilizados = anunciosCount[pacoteId] ?? anunciosCountPlano[planoId] ?? 0;
    }

    if ((typeof disponiveis === 'undefined' || disponiveis === null) && typeof limite !== 'undefined' && limite !== null) {
      disponiveis = Number(limite) - Number(utilizados);
    }

    const temLimite = typeof limite !== 'undefined' && limite !== null;
    const temUtilizados = typeof utilizados !== 'undefined' && utilizados !== null;
    const temDisponiveis = typeof disponiveis !== 'undefined' && disponiveis !== null;
    return { limite, utilizados, disponiveis, temLimite, temUtilizados, temDisponiveis };
  }, [anunciosCount, anunciosCountPlano]);

  // Verifica se existe algum pacote ativo com disponibilidade (mesma fonte da tela Meus Pacotes)
  const checkAnyPackageAvailability = useCallback(async () => {
    try {
      const token = localStorage.getItem('auth_token');

      const response = await fetch(`${import.meta.env.VITE_URL_API}/checkouts`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'accept': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        }
      });

      console.log('Resposta da API de pacotes:', response);

      if (!response.ok) {
        setPlanoBloqueado(false);
        return;
      }

      const data = await response.json();
      const checkouts = Array.isArray(data) ? data : (data?.checkouts || data);

      const now = new Date();
      now.setHours(0, 0, 0, 0);

      let totalDisponivel = 0;

      checkouts.forEach(item => {
        if (item.ativoCHECKOUT !== 1) return;

        const dataAquisicao = new Date(item.dataCHECKOUT);
        const validade = new Date(dataAquisicao);
        validade.setDate(validade.getDate() + Number(item.periodoCHECKOUT));
        validade.setHours(23, 59, 59, 999);

        if (validade < now) return;

        const { disponiveis } = getPacoteContagem(item);
        const disponivel = Number(disponiveis);

        if (disponivel > 0) {
          totalDisponivel += disponivel;
        }
      });

      if (totalDisponivel === 0) {
        setPlanoBloqueado(true);
        setMotivoBloqueio('Todos os seus pacotes ativos estão esgotados. Por favor, adquira um novo pacote para publicar anúncios.');
      } else {
        setPlanoBloqueado(false);
        setMotivoBloqueio('');
      }

    } catch (error) {
      console.error('Erro ao verificar disponibilidade de pacotes:', error);
      setPlanoBloqueado(false);
      setMotivoBloqueio('');
    }
  }, [getPacoteContagem]);
  const [eurRate, setEurRate] = useState(null); // 1 EUR = eurRate unidades da moeda escolhida
  const [valorMoeda, setValorMoeda] = useState(''); // valor digitado na moeda escolhida
  const [currencies, setCurrencies] = useState([]); // lista de moedas da API
  const [selectedCurrency, setSelectedCurrency] = useState('EUR'); // ISO da moeda do anúncio
  const [showLightbox, setShowLightbox] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dragIndexRef = useRef(null);
  const hasHydratedRef = useRef(false);
  const [draftLoaded, setDraftLoaded] = useState(false);

  // Converte string monetária brasileira ("1.234,56") em número
  const parseMoney = (str) => {
    if (!str) return 0;
    try {
      const clean = String(str).replace(/[^0-9,]/g, '').replace(/\./g, '');
      const normalized = clean.replace(',', '.');
      const num = parseFloat(normalized);
      return Number.isFinite(num) ? num : 0;
    } catch {
      return 0;
    }
  };


  // Busca cotação para converter moeda selecionada → EUR (1 EUR = X moeda)
  React.useEffect(() => {
    const iso = selectedCurrency || 'EUR';
    if (!iso || iso === 'EUR') {
      setEurRate(1);
      return;
    }
    
    // Taxas de fallback aproximadas (1 EUR = X moeda)
    const fallbackRates = {
      'BRL': 6.0,    // Real Brasileiro
      'AOA': 900.0,  // Kwanza Angolano
      'USD': 1.1,    // Dólar Americano
      'GBP': 0.85,   // Libra Esterlina
      'MZN': 68.0,   // Metical Moçambicano
      'CVE': 110.0,  // Escudo Cabo-verdiano
    };
    const fallbackRate = fallbackRates[iso] || 6.0;

    const fetchRate = async () => {
      try {
        const res = await fetch(`https://api.exchangerate.host/latest?base=EUR&symbols=${iso}`);
        if (!res.ok) {
          console.warn(`Falha ao buscar cotação EUR→${iso}, usando fallback ${fallbackRate}`);
          setEurRate(fallbackRate);
          return;
        }
        const data = await res.json();
        const rate = data?.rates?.[iso];
        if (rate && typeof rate === 'number' && rate > 0) {
          setEurRate(rate);
          console.log(`Cotação EUR→${iso}: ${rate}`);
        } else {
          console.warn(`Cotação inválida EUR→${iso}, usando fallback ${fallbackRate}`);
          setEurRate(fallbackRate);
        }
      } catch (err) {
        console.warn(`Erro ao buscar cotação EUR→${iso}, usando fallback ${fallbackRate}`, err);
        setEurRate(fallbackRate);
      }
    };
    fetchRate();
  }, [selectedCurrency]);

  // Carrega lista de moedas da API para o cadastro do anúncio
  useEffect(() => {
    const fetchCurrencies = async () => {
      try {
        const res = await fetch(`${import.meta.env.VITE_URL_API}/moedas`);
        const data = await res.json();
        if (data && Array.isArray(data.Registros)) {
          setCurrencies(data.Registros);
        }
      } catch (e) {
        console.error('Erro ao carregar lista de moedas', e);
      }
    };
    fetchCurrencies();
  }, []);

  // Atualiza completedSteps ao avançar ou voltar etapas
  const goToStep = (step) => {
    // Impede ir para etapas futuras sem validação
    if (step > currentStep) {
      for (let s = currentStep; s < step; s += 1) {
        if (!validateStep(s)) {
          showToast('Conclua a etapa atual antes de avançar.', 'error');
          return;
        }
      }
      setCompletedSteps(prev => {
        const merged = new Set(prev);
        for (let s = currentStep; s < step; s += 1) {
          merged.add(s);
        }
        return Array.from(merged).sort((a, b) => a - b);
      });
    }

    setCurrentStep(step);
    if (step < currentStep) {
      // Ao voltar remove futuras
      setCompletedSteps(prev => prev.filter(s => s <= step));
    }
  };
  const [formData, setFormData] = useState(() => {
    // Permite iniciar com dados vindos de props (edição) ou vazio (novo)
    if (typeof window !== 'undefined' && window.history.state && window.history.state.editImovel) {
      return { ...INITIAL_FORM_DATA, ...window.history.state.editImovel };
    }
    return { ...INITIAL_FORM_DATA };
  });
  const getCurrencySymbol = (iso) => {
    if (!iso) return '€';
    const found = (currencies || []).find(c => c.isoMOEDA === iso);
    if (found?.simboloMOEDA) return found.simboloMOEDA;
    const fallback = {
      'BRL': 'R$',
      'USD': 'US$',
      'EUR': '€',
      'GBP': '£',
      'AOA': 'Kz',
      'MZN': 'MT',
      'CVE': '$'
    };
    return fallback[String(iso).toUpperCase()] || '€';
  };
  const [tiposImovel, setTiposImovel] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [planosCheckout, setPlanosCheckout] = useState([]);

  // Garante que planosCheckout seja sempre um array
  const safePlanosCheckout = React.useMemo(() => Array.isArray(planosCheckout) ? planosCheckout : [], [planosCheckout]);
  const [imobiliarias, setImobiliarias] = useState([]);
  const [agentes, setAgentes] = useState([]);

  // Autocomplete Google Places
  const [addressSuggestions, setAddressSuggestions] = useState([]);
  const autocompleteTimeout = useRef(null);

  // Sincroniza selectedCurrency com formData.moedaIMOVEL ao carregar
  useEffect(() => {
    if (!formData.moedaIMOVEL) return;
    // Não sobrescrever selectedCurrency se já foi definido pelo rascunho
    if (draftLoaded && selectedCurrency === formData.moedaIMOVEL) return;
    setSelectedCurrency(formData.moedaIMOVEL);
  }, [formData.moedaIMOVEL, draftLoaded, selectedCurrency]);

  // Busca sugestões usando a Google Maps JS API
  const handleAddressAutocomplete = (e) => {
    const value = e.target.value;
    setFormData(prev => ({ ...prev, enderecoIMOVEL: value }));
    if (autocompleteTimeout.current) clearTimeout(autocompleteTimeout.current);
    if (!value) {
      setAddressSuggestions([]);
      return;
    }
    autocompleteTimeout.current = setTimeout(() => {
      if (!window.google || !window.google.maps || !window.google.maps.places) {
        return;
      }
      const service = new window.google.maps.places.AutocompleteService();
      // Restringe por país quando possível (usa ISO2 em paisIMOVEL, ex.: 'PT')
      const rawCountry = String((formData.paisIMOVEL || '')).trim();
      const toIso2 = (val) => {
        const v = String(val).trim().toLowerCase();
        if (v.length === 2) return v; // já ISO2
        if (v.includes('portugal') || v === 'pt-pt') return 'pt';
        if (v.includes('brasil') || v.includes('brazil')) return 'br';
        if (v.includes('angola')) return 'ao';
        if (v.includes('moçambique') || v.includes('mocambique')) return 'mz';
        return '';
      };
      const countryIso2 = toIso2(rawCountry);
      const reqBase = { input: value, language: 'pt' };
      const reqWithCountry = countryIso2 ? { ...reqBase, componentRestrictions: { country: countryIso2 } } : reqBase;

      service.getPlacePredictions(reqWithCountry, (predictions, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions && predictions.length) {
          setAddressSuggestions(predictions);
          return;
        }
        // Fallback: tenta novamente sem restrição de país
        service.getPlacePredictions(reqBase, (pred2, status2) => {
          if (status2 === window.google.maps.places.PlacesServiceStatus.OK) {
            setAddressSuggestions(pred2 || []);
          } else {
            setAddressSuggestions([]);
          }
        });
      });
    }, 400);
  };

  // Busca detalhes do endereço selecionado usando PlacesService
  const handleSelectAddress = (suggestion) => {
    setAddressSuggestions([]);
    setFormData(prev => ({ ...prev, enderecoIMOVEL: suggestion.description }));
    if (!window.google || !window.google.maps || !window.google.maps.places) return;
    const service = new window.google.maps.places.PlacesService(document.createElement('div'));
    service.getDetails({ placeId: suggestion.place_id, language: 'pt' }, (data, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK && data) {
        const { address_components, geometry } = data;
        let numero = '', cidade = '', estado = '', pais = '', cep = '';
        address_components.forEach(comp => {
          if (comp.types.includes('street_number')) numero = comp.long_name;
          // Em PT a cidade geralmente vem em 'locality'; no BR é comum em 'administrative_area_level_2'
          if (comp.types.includes('locality')) cidade = comp.long_name;
          if (!cidade && comp.types.includes('administrative_area_level_2')) cidade = comp.long_name;
          if (comp.types.includes('administrative_area_level_1')) estado = comp.short_name || comp.long_name;
          if (comp.types.includes('country')) pais = comp.long_name;
          if (comp.types.includes('postal_code')) cep = comp.long_name;
        });
        // Garante que fotos e outros campos não sejam perdidos ao preencher endereço
        setFormData(prev => ({
          ...prev,
          enderecoIMOVEL: suggestion.description,
          numeroIMOVEL: numero,
          cityIMOVEL: cidade,
          stateIMOVEL: estado,
          paisIMOVEL: pais,
          zipcodeIMOVEL: cep,
          latitudeIMOVEL: geometry.location.lat(),
          longitudeIMOVEL: geometry.location.lng(),
          fotos: prev.fotos // mantém as fotos já adicionadas
        }));
      }
    });
  };

  // Carrega tipos de imóvel ao montar
  React.useEffect(() => {
    const fetchTipos = async () => {
      try {
        const token = localStorage.getItem('auth_token');
        const response = await fetch(`${import.meta.env.VITE_URL_API}/tiposimovel`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'accept': 'application/json'
          }
        });
        if (response.ok) {
          const data = await response.json();
          setTiposImovel(data);
        }
      } catch (err) {
        setTiposImovel([]);
      }
    };
    fetchTipos();
  }, []);

  // Detecta perfil do usuário (PARTICULAR/PROFISSIONAL/EMPREENDIMENTO/ADMIN/USUARIO) e guarda dados do usuário logado
  React.useEffect(() => {
    try {
      const rawUser = localStorage.getItem('user');
      const authRole = localStorage.getItem('auth_role');
      const authToken = localStorage.getItem('auth_token');
      const upper = (s) => (s || '').toString().trim().toUpperCase();
      const tokenize = (s) => upper(s).split(/[^A-Z]+/).filter(Boolean);
      const official = new Set(['ADMIN','PROFISSIONAL','EMPREENDIMENTO','PARTICULAR','USUARIO']);

      // 1) JWT tem prioridade
      let detected = '';
      try {
        if (authToken && authToken.split('.').length === 3) {
          const b64url = authToken.split('.')[1];
          const b64 = b64url.replace(/-/g, '+').replace(/_/g, '/').padEnd(Math.ceil(b64url.length / 4) * 4, '=');
          const payload = JSON.parse(atob(b64));
          const jwtRole = upper(payload.role || payload.perfil || payload.tipo || payload.nivel || payload.papel || '');
          const tok = tokenize(jwtRole).find(t => official.has(t));
          if (tok) detected = tok;
        }
      } catch {
        // Ignore JWT parsing errors
      }

      // 2) Fallback: auth_role e user
      if (!detected && authRole) {
        const tok = tokenize(authRole).find(t => official.has(t));
        if (tok) detected = tok;
      }
      if (rawUser) {
        try { setCurrentUser(JSON.parse(rawUser)); } catch {
          // Ignore user parsing errors
        }
        if (!detected) {
          try {
            const u = JSON.parse(rawUser);
            const raw = u.perfil || u.perfilUSUARIO || u.role || u.tipo || u.nivel || u.papel || '';
            const tok = tokenize(raw).find(t => official.has(t));
            if (tok) detected = tok;
          } catch {
            // Ignore user role parsing errors
          }
        }
      }
      setRole(detected || 'PARTICULAR');
    } catch {
      // Ignore role detection errors
      }
  }, []);

  // Carrega planos ao montar (mesma fonte da tela Meus Pacotes)
  React.useEffect(() => {
    const fetchPlanos = async () => {
      try {
        const token = localStorage.getItem('auth_token');
        const response = await fetch(`${import.meta.env.VITE_URL_API}/checkouts`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'accept': 'application/json',
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
          }
        });
        if (response.ok) {
          const data = await response.json();
          const planos = Array.isArray(data) ? data : (data?.checkouts || data?.Registros || []);
          console.log('Resposta da API de pacotes:', response);
          console.log('Pacotes recebidos:', planos);
          setPlanosCheckout(planos);
          fetchAnunciosCount();
        } else {
          console.error('[NewListing] Erro na resposta de /checkouts:', response.status, response.statusText);
        }
      } catch (error) {
        console.error('Erro ao buscar planos:', error);
      }
    };
    fetchPlanos();
  }, [fetchAnunciosCount]);

  // Verificar disponibilidade de pacotes ao montar e quando planos mudarem
  React.useEffect(() => {
    checkAnyPackageAvailability();
  }, [planosCheckout, checkAnyPackageAvailability]);

  // Carrega categorias ao montar
  React.useEffect(() => {
    const fetchCategorias = async () => {
      try {
        const token = localStorage.getItem('auth_token');
        const response = await fetch(`${import.meta.env.VITE_URL_API}/categorias`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'accept': 'application/json'
          }
        });
        if (response.ok) {
          const data = await response.json();
          setCategorias(data);
        }
      } catch (err) {
        setCategorias([]);
      }
    };
    fetchCategorias();
  }, []);

  // Filtra categorias conforme tipo selecionado
  const categoriasFiltradas = formData.tipoIMOVEL
    ? categorias.filter(cat => String(cat.tipoCATEGORIA) === String(formData.tipoIMOVEL))
    : categorias;

  // Filtra planos conforme tipo selecionado

  // Carrega tipos de imóvel ao montar
  React.useEffect(() => {
    const fetchTipos = async () => {
      try {
        const token = localStorage.getItem('auth_token');
        const response = await fetch(`${import.meta.env.VITE_URL_API}/tiposimovel`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'accept': 'application/json'
          }
        });
        if (response.ok) {
          const data = await response.json();
          setTiposImovel(data);
        }
      } catch (err) {
        setTiposImovel([]);
      }
    };
    fetchTipos();
  }, []);

  // Fetch imobiliarias from API on component mount
  React.useEffect(() => {
    const fetchImobiliarias = async () => {
      try {
        const token = localStorage.getItem('auth_token');
        const response = await fetch(`${import.meta.env.VITE_URL_API}/imobiliarias/me`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'accept': 'application/json'
          }
        });
        if (response.ok) {
          const data = await response.json();
          setImobiliarias(data);
        }
      } catch (err) {
        setImobiliarias([]);
      }
    };
    fetchImobiliarias();
  }, []);

  // Fetch agentes from API on component mount
  React.useEffect(() => {
    const fetchAgentes = async () => {
      try {
        const token = localStorage.getItem('auth_token');
        const imobFromForm = (formData?.imobiliariaIMOVEL) ? String(formData.imobiliariaIMOVEL) : '';
        let imobFromStorage = '';
        try { imobFromStorage = localStorage.getItem('selected_imobiliaria') || ''; } catch {
          // Ignore localStorage errors
          }
        const imobId = imobFromForm || imobFromStorage;

        const base = `${import.meta.env.VITE_URL_API}/agentes`;
        const urls = [
          `${import.meta.env.VITE_URL_API}/agentes/me`,
          imobId ? `${base}?imobiliaria=${imobId}` : '',
          imobId ? `${base}?codigoIMOBILIARIA=${imobId}` : '',
          base
        ].filter(Boolean);

        let raw = [];
        for (const url of urls) {
          const response = await fetch(url, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'accept': 'application/json'
            }
          });
          if (!response.ok) continue;
          const body = await response.json();
          raw = Array.isArray(body) ? body : (Array.isArray(body?.dados) ? body.dados : []);
          if (Array.isArray(raw) && raw.length > 0) break;
        }

        const norm = (Array.isArray(raw) ? raw : []).map(a => ({
          codigoAGENTE: a.codigoAGENTE ?? a.codigo ?? a.id ?? a.codigoAgente,
          nomeAGENTE: a.nomeAGENTE ?? a.nome ?? a.name ?? a.descricaoAGENTE ?? '',
          ...a
        })).filter(a => a.codigoAGENTE && a.nomeAGENTE);
        setAgentes(norm);
      } catch (err) {
        setAgentes([]);
      }
    };
    fetchAgentes();
  }, [formData?.imobiliariaIMOVEL]);

  // Carrega os dados do formulário e progresso do draft ao montar o componente
  React.useEffect(() => {
    if (typeof window === 'undefined') {
      hasHydratedRef.current = true;
      return;
    }

    const draftKey = `newListingDraft:${userId}`;
    console.log('🔍 [DRAFT DEBUG] Iniciando carregamento do rascunho');
    console.log('🔍 [DRAFT DEBUG] Chave do rascunho:', draftKey);
    console.log('🔍 [DRAFT DEBUG] userId:', userId);
    console.log('🔍 [DRAFT DEBUG] Conteúdo atual do localStorage:', localStorage.getItem(draftKey));

    try {
      const savedDraft = localStorage.getItem(draftKey);
      console.log('🔍 [DRAFT DEBUG] Rascunho encontrado ao carregar:', savedDraft);

      if (savedDraft) {
        const draftData = JSON.parse(savedDraft);
        console.log('🔍 [DRAFT DEBUG] Dados do rascunho parseado:', draftData);

        // Restaura fotos locais salvas em chave separada, se existirem
        try {
          const savedPhotos = localStorage.getItem(`${draftKey}:fotos`);
          console.log('🔍 [DRAFT DEBUG] Fotos locais no localStorage:', savedPhotos);
          if (savedPhotos) {
            const parsedPhotos = JSON.parse(savedPhotos);
            console.log('🔍 [DRAFT DEBUG] Fotos locais parseadas:', parsedPhotos);
            if (Array.isArray(parsedPhotos.fotos) && parsedPhotos.fotos.length > 0) {
              draftData.formData.fotos = [...(draftData.formData.fotos || []), ...parsedPhotos.fotos];
              console.log('🔍 [DRAFT DEBUG] Fotos locais restauradas:', parsedPhotos.fotos.length);
              console.log('🔍 [DRAFT DEBUG] Total de fotos após restauração:', draftData.formData.fotos.length);
            }
          }
        } catch (photoErr) {
          console.warn('🔍 [DRAFT DEBUG] Erro ao restaurar fotos locais:', photoErr);
        }

        // Check if currency is BRL and clear if necessary
        if (draftData.formData?.moedaIMOVEL === 'BRL') {
          console.log('🔍 [DRAFT DEBUG] Moeda BRL detectada, limpando rascunho');
          localStorage.removeItem(draftKey);
          localStorage.removeItem(`${draftKey}:fotos`);
          setFormData({ ...INITIAL_FORM_DATA });
          setSelectedCurrency('EUR');
        } else {
          console.log('🔍 [DRAFT DEBUG] Restaurando rascunho com dados:', draftData.formData);
          console.log('🔍 [DRAFT DEBUG] Step do rascunho:', draftData.currentStep);
          console.log('🔍 [DRAFT DEBUG] Completed steps do rascunho:', draftData.completedSteps);
          console.log('🔍 [DRAFT DEBUG] selectedCurrency do rascunho:', draftData.selectedCurrency);
          console.log('🔍 [DRAFT DEBUG] valorMoeda do rascunho:', draftData.valorMoeda);

          setFormData(prev => {
            const restored = { ...prev, ...draftData.formData };
            console.log('🔍 [DRAFT DEBUG] Estado após restauração:', restored);
            return restored;
          });
          setCurrentStep(draftData.currentStep || 1);
          setCompletedSteps(draftData.completedSteps || []);
          if (draftData.selectedCurrency) {
            setSelectedCurrency(draftData.selectedCurrency);
          }
          if (draftData.valorMoeda) {
            setValorMoeda(draftData.valorMoeda);
          }

          // Show restoration notification
          setDraftRestored(true);
          setTimeout(() => setDraftRestored(false), 5000);
        }
      } else {
        console.log('🔍 [DRAFT DEBUG] Nenhum rascunho encontrado, usando formulário inicial');
      }
    } catch (err) {
      console.error('🔍 [DRAFT DEBUG] Erro ao carregar draft:', err);
      setFormData({ ...INITIAL_FORM_DATA });
      setSelectedCurrency('EUR');
    } finally {
      hasHydratedRef.current = true;
      setDraftLoaded(true);
      console.log('🔍 [DRAFT DEBUG] Carregamento do rascunho concluído, draftLoaded = true');
    }
  }, [userId]);

  // Garante salvamento ao fechar/atualizar a aba
  React.useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const handleBeforeUnload = () => {
      if (!skipDraftPersistRef.current) {
        console.log('🔍 [DRAFT DEBUG] beforeUnload: salvando rascunho');
        try {
          const draftKey = `newListingDraft:${userId}`;
          const LocalPhotos = (formData.fotos || []).filter(f => f && f.pathFOTO && f.pathFOTO.startsWith('data:'));
          const serverPhotos = (formData.fotos || []).filter(f => f && f.urlFOTO && !f.urlFOTO.startsWith('data:'));
          const draftPayload = {
            formData: { ...formData, fotos: serverPhotos },
            currentStep,
            completedSteps,
            selectedCurrency,
            valorMoeda,
            updatedAt: new Date().toISOString()
          };
          localStorage.setItem(draftKey, JSON.stringify(draftPayload));
          console.log('🔍 [DRAFT DEBUG] beforeUnload: rascunho salvo com sucesso');
        } catch (err) {
          console.error('🔍 [DRAFT DEBUG] beforeUnload: erro ao salvar rascunho:', err);
        }
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [formData, currentStep, completedSteps, userId, selectedCurrency, valorMoeda]);

  // Persiste automaticamente o formulário e progresso após hidratação
  useEffect(() => {
    if (!userId) {
      console.warn('🔍 [DRAFT DEBUG] userId ausente, rascunho não será salvo');
      return;
    }
    if (!hasHydratedRef.current) {
      console.log('🔍 [DRAFT DEBUG] hasHydratedRef.current = false, aguardando hidratação');
      return;
    }
    if (!draftLoaded) {
      console.log('🔍 [DRAFT DEBUG] draftLoaded = false, aguardando carregamento do rascunho');
      return;
    }
    if (skipDraftPersistRef.current) {
      console.log('🔍 [DRAFT DEBUG] skipDraftPersistRef.current = true, ignorando salvamento');
      return;
    }

    const draftKey = `newListingDraft:${userId}`;
    console.log('🔍 [DRAFT DEBUG] Iniciando salvamento do rascunho');
    console.log('🔍 [DRAFT DEBUG] Chave do rascunho:', draftKey);
    console.log('🔍 [DRAFT DEBUG] Dados a serem salvos:', {
      formDataKeys: Object.keys(formData),
      currentStep,
      completedSteps
    });

    // Separa fotos locais (base64) do resto do formulário para não estourar o localStorage.
    // Se couber, salvamos as fotos em chave separada; o draft principal fica sempre salvo.
    const LocalPhotos = (formData.fotos || []).filter(f => f && f.pathFOTO && f.pathFOTO.startsWith('data:'));
    const serverPhotos = (formData.fotos || []).filter(f => f && f.urlFOTO && !f.urlFOTO.startsWith('data:'));
    console.log('🔍 [DRAFT DEBUG] Fotos totais:', (formData.fotos || []).length);
    console.log('🔍 [DRAFT DEBUG] Fotos locais (base64):', LocalPhotos.length);
    console.log('🔍 [DRAFT DEBUG] Fotos do servidor:', serverPhotos.length);
    const draftPayload = {
      formData: { ...formData, fotos: serverPhotos },
      currentStep,
      completedSteps,
      selectedCurrency,
      valorMoeda,
      updatedAt: new Date().toISOString()
    };

    console.log('🔍 [DRAFT DEBUG] Payload do rascunho:', draftPayload);

    try {
      const serialized = JSON.stringify(draftPayload);
      console.log('🔍 [DRAFT DEBUG] Tamanho do rascunho serializado:', serialized.length);
      localStorage.setItem(draftKey, serialized);
      console.log('🔍 [DRAFT DEBUG] Rascunho salvo com sucesso');
      console.log('🔍 [DRAFT DEBUG] Conteúdo do localStorage após salvamento:', localStorage.getItem(draftKey));
    } catch (err) {
      console.error('🔍 [DRAFT DEBUG] Erro ao salvar formulário no draft:', err);
    }

    try {
      if (LocalPhotos.length > 0) {
        const photosPayload = {
          fotos: LocalPhotos,
          updatedAt: new Date().toISOString()
        };
        localStorage.setItem(
          `${draftKey}:fotos`,
          JSON.stringify(photosPayload)
        );
        console.log('🔍 [DRAFT DEBUG] Fotos locais salvas:', LocalPhotos.length);
      } else {
        localStorage.removeItem(`${draftKey}:fotos`);
      }
    } catch (err) {
      console.warn('🔍 [DRAFT DEBUG] Não foi possível salvar fotos locais:', err);
    }
  }, [formData, currentStep, completedSteps, userId, draftLoaded, selectedCurrency, valorMoeda]);

  // Extrai o clienteIMOVEL do auth_token no localStorage
  React.useEffect(() => {
    try {
      const token = localStorage.getItem('auth_token');
      if (token) {
        const payload = JSON.parse(atob(token.split('.')[1])); // Decodifica o payload do JWT
        if (payload && payload.codigo) {
          setFormData(prev => ({ ...prev, clienteIMOVEL: payload.codigo }));
        }
      }
    } catch (err) {
      console.error('Erro ao extrair clienteIMOVEL do auth_token:', err);
    }
  }, []);

  const steps = [
    { number: 1, text: 'Informações Básicas' },
    { number: 2, text: 'Mídias' },
    { number: 3, text: 'Localização' },
    { number: 4, text: 'Comodidades' },
    { number: 5, text: 'Regras e Preços' },
  ];

  // Limite máximo de fotos por anúncio
  const MAX_FOTOS = 200;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handlePhotoUpload = (e) => {
    let files = Array.from(e.target.files || []);
    if (!files.length) return;

    const currentCount = Array.isArray(formData.fotos) ? formData.fotos.length : 0;
    const remaining = MAX_FOTOS - currentCount;
    if (remaining <= 0) {
      try { showToast(`Limite de ${MAX_FOTOS} fotos atingido.`, 'error'); } catch {
        // Ignore toast errors
        }
      return;
    }
    if (files.length > remaining) {
      files = files.slice(0, remaining);
      try { showToast(`Você pode adicionar mais ${remaining} foto(s). As demais foram ignoradas.`, 'error'); } catch {
        // Ignore toast errors
      }
    }

    files.forEach(file => {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData(prev => {
          if (!Array.isArray(prev.fotos)) prev.fotos = [];
          if (prev.fotos.length >= MAX_FOTOS) return prev;
          const newFotos = [
            ...prev.fotos,
            {
              codigoFOTO: Date.now() + Math.floor(Math.random() * 10000),
              imovelFOTO: prev.codigoIMOVEL || '',
              pathFOTO: reader.result, // base64 temporário
              urlFOTO: '',
              padraoFOTO: prev.fotos.length === 0 ? 1 : 0
            }
          ];
          return { ...prev, fotos: newFotos };
        });
      };
      reader.readAsDataURL(file);
    });
  };

  const handleRemovePhoto = (index) => {
    setFormData(prev => {
      const newFotos = prev.fotos.filter((_, i) => i !== index);
      return {
        ...prev,
        fotos: newFotos.map((f, i) => ({ ...f, padraoFOTO: i === 0 ? 1 : 0 }))
      };
    });
  };

  // Drag and drop ordering
  const handleDragStart = (index) => {
    dragIndexRef.current = index;
  };
  const handleDragOver = (e) => {
    e.preventDefault();
  };
  const handleDrop = (targetIndex) => {
    const from = dragIndexRef.current;
    if (from === null || from === undefined || from === targetIndex) return;
    setFormData(prev => {
      const arr = Array.isArray(prev.fotos) ? [...prev.fotos] : [];
      const [moved] = arr.splice(from, 1);
      arr.splice(targetIndex, 0, moved);
      // Recalcula principal: índice 0 vira padraoFOTO = 1
      const ordered = arr.map((f, i) => ({ ...f, padraoFOTO: i === 0 ? 1 : 0 }));
      return { ...prev, fotos: ordered };
    });
    dragIndexRef.current = null;
  };

  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return (
          <FormSection>
            <SectionTitle>Informações Básicas</SectionTitle>
            <FormGrid>
              {planoBloqueado && (
                <div style={{ gridColumn: '1 / -1', background: '#fee', border: '1px solid #fcc', borderRadius: 8, padding: 16, marginBottom: 24, color: '#c00' }}>
                  <strong style={{ fontSize: 16 }}>{motivoBloqueio}</strong>
                </div>
              )}

              <InputGroup>
                <Label htmlFor="tituloIMOVEL" className="required">Título do Anúncio</Label>
                <Input
                  id="tituloIMOVEL"
                  name="tituloIMOVEL"
                  value={formData.tituloIMOVEL}
                  onChange={e => {
                    handleChange(e);
                    const slug = e.target.value
                      .normalize('NFD')
                      .replace(/[\u0300-\u036f]/g, '')
                      .toLowerCase()
                      .trim()
                      .replace(/[^a-z0-9]+/g, '-')
                      .replace(/(^-|-$)/g, '');
                    setFormData(prev => ({ ...prev, slugIMOVEL: slug }));
                  }}
                  placeholder="Ex: Apartamento moderno no centro"
                  required
                  disabled={planoBloqueado}
                />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="slugIMOVEL">Slug</Label>
                <Input id="slugIMOVEL" name="slugIMOVEL" value={formData.slugIMOVEL} readOnly style={{ background: '#f7fafc', color: '#a0aec0' }} placeholder="Gerado automaticamente" disabled={planoBloqueado} />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="pacoteIMOVEL" className="required">Pacote</Label>
                <ReactSelect
                  inputId="pacoteIMOVEL"
                  name="pacoteIMOVEL"
                  isDisabled={false}
                  options={(() => {
                    if (!Array.isArray(planosCheckout)) {
                      console.warn('[NewListing] planosCheckout não é um array:', planosCheckout);
                      return [];
                    }

                    const now = new Date();
                    now.setHours(0, 0, 0, 0);

                    const pacotesDisponiveis = safePlanosCheckout.filter(pkg => {
                      if (!pkg || !pkg.codigoCHECKOUT) return false;
                      const ativo = Number(pkg.ativoCHECKOUT) === 1;
                      const dataAquisicao = pkg.dataCHECKOUT ? new Date(pkg.dataCHECKOUT) : null;
                      const validade = dataAquisicao ? new Date(dataAquisicao.getTime()) : null;
                      if (validade) validade.setDate(validade.getDate() + Number(pkg.periodoCHECKOUT || 0));
                      const vigente = ativo && validade && validade >= now;
                      const cancelado = pkg.ativoCHECKOUT === 5;
                      return vigente && !cancelado;
                    });

                    const mapped = pacotesDisponiveis.map(pkg => {
                      const { limite, utilizados, disponiveis } = getPacoteContagem(pkg);
                      const qtd = typeof limite !== 'undefined' && limite !== null ? limite : '-';
                      const usados = typeof utilizados !== 'undefined' && utilizados !== null ? utilizados : '-';
                      const nome = pkg.nomeCHECKOUT || pkg.nomePLANO || pkg.plano?.nomePLANO || 'Plano';
                      const tipo = pkg.plano?.tipoPlano?.planoTIPOPLANO || pkg.plano?.tipoPlano?.nomeTIPOPLANO || '';
                      const esgotado = Number(disponiveis) <= 0;
                      const label = tipo ? `${tipo} - ${nome} (Utilizados: ${usados} de ${qtd})` : `${nome} (Utilizados: ${usados} de ${qtd})`;
                      return {
                        value: pkg.codigoCHECKOUT,
                        label,
                        isDisabled: esgotado,
                        'aria-label': esgotado ? `${label} [Esgotado]` : label
                      };
                    });

                    console.log('Pacotes disponíveis após filtro:', mapped);
                    return mapped;
                  })()}
                  value={(() => {
                    const selected = (planosCheckout || []).find(pkg => String(pkg.codigoCHECKOUT) === String(formData.pacoteIMOVEL));
                    if (!selected) return null;
                    const { limite, utilizados } = getPacoteContagem(selected);
                    const qtd = typeof limite !== 'undefined' && limite !== null ? limite : '-';
                    const usados = typeof utilizados !== 'undefined' && utilizados !== null ? utilizados : '-';
                    const nome = selected.nomeCHECKOUT || selected.nomePLANO || selected.plano?.nomePLANO || 'Plano';
                    const tipo = selected.plano?.tipoPlano?.planoTIPOPLANO || selected.plano?.tipoPlano?.nomeTIPOPLANO || '';
                    return { value: selected.codigoCHECKOUT, label: tipo ? `${tipo} - ${nome} (Utilizados: ${usados} de ${qtd})` : `${nome} (Utilizados: ${usados} de ${qtd})` };
                  })()}
                  onChange={option => {
                    handleChange({ target: { name: 'pacoteIMOVEL', value: option?.value || '' } });
                    const selected = option && option.value
                      ? (planosCheckout || []).find(pkg => String(pkg.codigoCHECKOUT) === String(option.value))
                      : null;

                    const planoId = selected?.plano?.codigoPLANO || selected?.plano;
                    // Verifica disponibilidade em todos os pacotes ativos
                    checkAnyPackageAvailability();

                    if (selected && planoId) {
                      setFormData(prev => ({ ...prev, planoIMOVEL: planoId }));
                      // Valida compatibilidade do tipo de imóvel com o plano
                      if (formData.tipoIMOVEL) {
                        const slugPlano = selected?.plano?.tipoPlano?.slugTIPOPLANO ||
                          (selected?.plano?.tipoPLANO === 1 ? 'destaque' :
                           selected?.plano?.tipoPLANO === 2 ? 'particular' :
                           selected?.plano?.tipoPLANO === 3 ? 'professional' :
                           selected?.plano?.tipoPLANO === 4 ? 'ferias' : null);
                        const tipoSel = tiposImovel.find(t => String(t.codigoTIPOIMOVEL) === String(formData.tipoIMOVEL));
                        if (tipoSel && slugPlano) {
                          const permitido =
                            (slugPlano === 'professional' || slugPlano === 'particular') && ['arrendar', 'comprar'].includes(tipoSel.slugTIPOIMOVEL) ||
                            (slugPlano === 'ferias' || slugPlano === 'vacation') && tipoSel.slugTIPOIMOVEL === 'ferias' ||
                            (slugPlano === 'destaque') && tipoSel.slugTIPOIMOVEL !== 'ferias';
                          if (!permitido) {
                            setFormData(prev => ({ ...prev, tipoIMOVEL: '' }));
                            setTipoIncompativel(true);
                            setTimeout(() => setTipoIncompativel(false), 5000);
                          }
                        }
                      }
                    } else {
                      setFormData(prev => ({ ...prev, planoIMOVEL: '' }));
                    }
                  }}
                  placeholder="Selecione um pacote"
                  isClearable
                  required
                />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="planoIMOVEL">Plano</Label>
                <ReactSelect
                  inputId="planoIMOVEL"
                  name="planoIMOVEL"
                  options={(() => {
                    // Verificação adicional de segurança
                    if (!Array.isArray(planosCheckout)) {
                      console.warn('[NewListing] planosCheckout não é um array:', planosCheckout);
                      return [];
                    }
                    // Se tem pacote selecionado, mostra só o plano relacionado
                    const selected = (planosCheckout || []).find(pkg => String(pkg.codigoCHECKOUT) === String(formData.pacoteIMOVEL));
                    if (selected && selected.plano && selected.plano.codigoPLANO && selected.plano.nomePLANO) {
                      return [{
                        value: selected.plano.codigoPLANO,
                        label: selected.plano.nomePLANO.replace(/<br\s*\/?>(\s*)?/gi, ' ').replace(/&nbsp;/g, ' ').trim()
                      }];
                    }
                    // Se não tem pacote, não mostra nada
                    return [];
                  })()}
                  value={(() => {
                    const selected = (planosCheckout || []).find(pkg => String(pkg.codigoCHECKOUT) === String(formData.pacoteIMOVEL));
                    if (selected && selected.plano && selected.plano.codigoPLANO && String(selected.plano.codigoPLANO) === String(formData.planoIMOVEL)) {
                      return {
                        value: selected.plano.codigoPLANO,
                        label: selected.plano.nomePLANO.replace(/<br\s*\/?>(\s*)?/gi, ' ').replace(/&nbsp;/g, ' ').trim()
                      };
                    }
                    return null;
                  })()}
                  onChange={option => handleChange({ target: { name: 'planoIMOVEL', value: option?.value || '' } })}
                  placeholder={formData.pacoteIMOVEL ? 'Plano vinculado ao pacote' : 'Selecione um pacote'}
                  isClearable
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      borderColor: state.isFocused ? '#34574A' : '#e2e8f0',
                      boxShadow: state.isFocused ? '0 0 0 3px rgba(52, 87, 74, 0.1)' : undefined,
                      minHeight: 48,
                      fontSize: 16
                    }),
                    option: (base, state) => ({
                      ...base,
                      background: state.isSelected ? '#34574A' : state.isFocused ? '#f0fff4' : '#fff',
                      color: state.isSelected ? '#fff' : '#2d3748',
                      fontSize: 16
                    })
                  }}
                  isDisabled={!formData.pacoteIMOVEL}
                />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="moedaIMOVEL" className="required">Moeda do anúncio</Label>
                <ReactSelect
                  inputId="moedaIMOVEL"
                  name="moedaIMOVEL"
                  options={(currencies || []).map(m => ({
                    value: m.isoMOEDA,
                    label: `${m.simboloMOEDA || m.isoMOEDA} — ${m.isoMOEDA}${m.nomeMOEDA ? ` (${m.nomeMOEDA})` : ''}`
                  }))}
                  value={(() => {
                    const iso = selectedCurrency || formData.moedaIMOVEL || 'EUR';
                    const cur = (currencies || []).find(m => m.isoMOEDA === iso);
                    return cur ? {
                      value: cur.isoMOEDA,
                      label: `${cur.simboloMOEDA || cur.isoMOEDA} — ${cur.isoMOEDA}${cur.nomeMOEDA ? ` (${cur.nomeMOEDA})` : ''}`
                    } : null;
                  })()}
                  onChange={option => {
                    const iso = option?.value || 'EUR';
                    setSelectedCurrency(iso);
                    setFormData(prev => ({ ...prev, moedaIMOVEL: iso }));
                  }}
                  placeholder="Selecione a moeda do anúncio..."
                  isClearable={false}
                  menuShouldBlockScroll={true}
                  closeMenuOnSelect={true}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      borderColor: state.isFocused ? '#34574A' : '#e2e8f0',
                      boxShadow: state.isFocused ? '0 0 0 3px rgba(52, 87, 74, 0.1)' : undefined,
                      minHeight: 48,
                      fontSize: 16
                    }),
                    option: (base, state) => ({
                      ...base,
                      background: state.isSelected ? '#34574A' : state.isFocused ? '#f0fff4' : '#fff',
                      color: state.isSelected ? '#fff' : '#2d3748',
                      fontSize: 16,
                      padding: '12px 16px',
                      cursor: 'pointer'
                    }),
                    menu: base => ({
                      ...base,
                      zIndex: 9999,
                      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                      border: '1px solid #e2e8f0',
                      borderRadius: 8
                    }),
                    menuList: base => ({
                      ...base,
                      padding: '4px 0',
                      maxHeight: '300px'
                    })
                  }}
                />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="tipoIMOVEL" className="required">Tipo de Imóvel</Label>
                {tipoIncompativel && (
                  <div style={{ color: '#b91c1c', fontSize: 12, marginBottom: 4 }}>
                    Tipo de imóvel não compatível com o plano selecionado. Selecione um tipo permitido.
                  </div>
                )}
                <ReactSelect
                  inputId="tipoIMOVEL"
                  name="tipoIMOVEL"
                  isDisabled={planoBloqueado}
                  options={(() => {
                    const selected = (planosCheckout || []).find(pkg => String(pkg.codigoCHECKOUT) === String(formData.pacoteIMOVEL));
                    // Fallback: usar tipoPLANO direto se tipoPlano não estiver disponível
                    const slugPlano = selected?.plano?.tipoPlano?.slugTIPOPLANO || 
                      (selected?.plano?.tipoPLANO === 1 ? 'destaque' :
                       selected?.plano?.tipoPLANO === 2 ? 'particular' : 
                       selected?.plano?.tipoPLANO === 3 ? 'professional' : 
                       selected?.plano?.tipoPLANO === 4 ? 'ferias' : null);
                    if (selected && selected.plano && slugPlano) {
                      if (slugPlano === 'professional' || slugPlano === 'particular') {
                        // Mostrar tipos com slug arrendar ou comprar (rotulando 'comprar' como 'Vender')
                        const tiposPermitidos = ['arrendar', 'comprar'];
                        return tiposPermitidos
                          .map(slug => tiposImovel.find(tipo => tipo.slugTIPOIMOVEL === slug))
                          .filter(Boolean)
                          .map(tipo => ({
                            value: tipo.codigoTIPOIMOVEL,
                            label: tipo.slugTIPOIMOVEL === 'comprar' ? 'Vender' : tipo.nomeTIPOIMOVEL
                          }));
                      }
                      if (slugPlano === 'ferias' || slugPlano === 'vacation') {
                        return tiposImovel.filter(tipo => tipo.slugTIPOIMOVEL === 'ferias').map(tipo => ({
                          value: tipo.codigoTIPOIMOVEL,
                          label: tipo.nomeTIPOIMOVEL
                        }));
                      }
                      if (slugPlano === 'destaque') {
                        // Para plano destaque, mostrar tudo exceto 'ferias'
                        return tiposImovel.filter(tipo => tipo.slugTIPOIMOVEL !== 'ferias').map(tipo => ({
                          value: tipo.codigoTIPOIMOVEL,
                          label: tipo.slugTIPOIMOVEL === 'comprar' ? 'Vender' : tipo.nomeTIPOIMOVEL
                        }));
                      }
                    }
                    // Se não há plano selecionado, mostrar todos os tipos
                    return tiposImovel.map(tipo => ({
                      value: tipo.codigoTIPOIMOVEL,
                      label: tipo.slugTIPOIMOVEL === 'comprar' ? 'Vender' : tipo.nomeTIPOIMOVEL
                    }));
                  })()}
                  value={(() => {
                    const tipoSel = tiposImovel.find(tipo => String(tipo.codigoTIPOIMOVEL) === String(formData.tipoIMOVEL));
                    if (!tipoSel) return null;
                    return {
                      value: formData.tipoIMOVEL,
                      label: tipoSel.slugTIPOIMOVEL === 'comprar' ? 'Vender' : (tipoSel.nomeTIPOIMOVEL)
                    };
                  })()}
                  onChange={option => {
                    handleChange({ target: { name: 'tipoIMOVEL', value: option?.value || '' } });
                    // Valida compatibilidade do tipo com o plano já selecionado
                    if (option && option.value && formData.pacoteIMOVEL) {
                      const selected = (planosCheckout || []).find(pkg => String(pkg.codigoCHECKOUT) === String(formData.pacoteIMOVEL));
                      if (selected && selected.plano) {
                        const slugPlano = selected?.plano?.tipoPlano?.slugTIPOPLANO || 
                          (selected?.plano?.tipoPLANO === 1 ? 'destaque' :
                           selected?.plano?.tipoPLANO === 2 ? 'particular' : 
                           selected?.plano?.tipoPLANO === 3 ? 'professional' : 
                           selected?.plano?.tipoPLANO === 4 ? 'ferias' : null);
                        const tipoSel = tiposImovel.find(t => String(t.codigoTIPOIMOVEL) === String(option.value));
                        if (tipoSel && slugPlano) {
                          const permitido =
                            (slugPlano === 'professional' || slugPlano === 'particular') && ['arrendar', 'comprar'].includes(tipoSel.slugTIPOIMOVEL) ||
                            (slugPlano === 'ferias' || slugPlano === 'vacation') && tipoSel.slugTIPOIMOVEL === 'ferias' ||
                            (slugPlano === 'destaque') && tipoSel.slugTIPOIMOVEL !== 'ferias';
                          if (!permitido) {
                            setTipoIncompativel(true);
                            setTimeout(() => setTipoIncompativel(false), 5000);
                          } else {
                            setTipoIncompativel(false);
                          }
                        }
                      }
                    }
                  }}
                  placeholder="Selecione o tipo..."
                  isClearable
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      borderColor: tipoIncompativel ? '#b91c1c' : (state.isFocused ? '#34574A' : '#e2e8f0'),
                      boxShadow: tipoIncompativel ? '0 0 0 3px rgba(185, 28, 28, 0.1)' : (state.isFocused ? '0 0 0 3px rgba(52, 87, 74, 0.1)' : undefined),
                      minHeight: 48,
                      fontSize: 16
                    }),
                    option: (base, state) => ({
                      ...base,
                      background: state.isSelected ? '#34574A' : state.isFocused ? '#f0fff4' : '#fff',
                      color: state.isSelected ? '#fff' : '#2d3748',
                      fontSize: 16
                    })
                  }}
                />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="categoriaIMOVEL" className="required">Categoria</Label>
                <ReactSelect
                  inputId="categoriaIMOVEL"
                  name="categoriaIMOVEL"
                  options={categoriasFiltradas.map(cat => ({
                    value: cat.codigoCATEGORIA,
                    label: cat.nomeCATEGORIA
                  }))}
                  value={categoriasFiltradas.find(cat => cat.codigoCATEGORIA === formData.categoriaIMOVEL)
                    ? {
                      value: formData.categoriaIMOVEL,
                      label: categoriasFiltradas.find(cat => cat.codigoCATEGORIA === formData.categoriaIMOVEL)?.nomeCATEGORIA
                    }
                    : null}
                  onChange={option => handleChange({ target: { name: 'categoriaIMOVEL', value: option?.value || '' } })}
                  placeholder="Selecione a categoria..."
                  isClearable
                  isDisabled={planoBloqueado}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      borderColor: state.isFocused ? '#34574A' : '#e2e8f0',
                      boxShadow: state.isFocused ? '0 0 0 3px rgba(52, 87, 74, 0.1)' : undefined,
                      minHeight: 48,
                      fontSize: 16
                    }),
                    option: (base, state) => ({
                      ...base,
                      background: state.isSelected ? '#34574A' : state.isFocused ? '#f0fff4' : '#fff',
                      color: state.isSelected ? '#fff' : '#2d3748',
                      fontSize: 16
                    })
                  }}
                />
              </InputGroup>



              <InputGroup className="full-width">
                <Label htmlFor="descricaoIMOVEL" className="required">Descrição</Label>
                <TextArea id="descricaoIMOVEL" name="descricaoIMOVEL" value={formData.descricaoIMOVEL} onChange={handleChange} placeholder="Descreva seu imóvel em detalhes..." required />
              </InputGroup>

              <InputGroup className="full-width">
                <Label htmlFor="regrasadicionaisIMOVEL">Regras Adicionais</Label>
                <TextArea id="regrasadicionaisIMOVEL" name="regrasadicionaisIMOVEL" value={formData.regrasadicionaisIMOVEL} onChange={handleChange} placeholder="Ex: Não permitido fumar, animais de estimação, festas, etc." />
              </InputGroup>

              {role !== 'PARTICULAR' && (
                <>
                  <InputGroup>
                    <Label htmlFor="imobiliariaIMOVEL">Imobiliária</Label>
                    <ReactSelect
                      inputId="imobiliariaIMOVEL"
                      name="imobiliariaIMOVEL"
                      options={imobiliarias.map(imobiliaria => ({
                        value: imobiliaria.codigoIMOBILIARIA,
                        label: imobiliaria.nomeIMOBILIARIA
                      }))}
                      value={imobiliarias.find(imobiliaria => String(imobiliaria.codigoIMOBILIARIA) === String(formData.imobiliariaIMOVEL))
                        ? {
                          value: formData.imobiliariaIMOVEL,
                          label: imobiliarias.find(imobiliaria => String(imobiliaria.codigoIMOBILIARIA) === String(formData.imobiliariaIMOVEL))?.nomeIMOBILIARIA
                        }
                        : null}
                      onChange={option => handleChange({ target: { name: 'imobiliariaIMOVEL', value: option?.value || '' } })}
                      placeholder="Selecione a imobiliária..."
                      isClearable
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          borderColor: state.isFocused ? '#34574A' : '#e2e8f0',
                          boxShadow: state.isFocused ? '0 0 0 3px rgba(52, 87, 74, 0.1)' : undefined,
                          minHeight: 48,
                          fontSize: 16
                        }),
                        option: (base, state) => ({
                          ...base,
                          background: state.isSelected ? '#34574A' : state.isFocused ? '#f0fff4' : '#fff',
                          color: state.isSelected ? '#fff' : '#2d3748',
                          fontSize: 16
                        })
                      }}
                    />
                  </InputGroup>

                  <InputGroup>
                    <Label htmlFor="agenteIMOVEL">Agente</Label>
                    <ReactSelect
                      inputId="agenteIMOVEL"
                      name="agenteIMOVEL"
                      options={(() => {
                        return agentes.map(agente => ({
                          value: agente.codigoAGENTE,
                          label: agente.nomeAGENTE
                        }));
                      })()}
                      value={agentes.find(agente => String(agente.codigoAGENTE) === String(formData.agenteIMOVEL))
                        ? {
                          value: formData.agenteIMOVEL,
                          label: agentes.find(agente => String(agente.codigoAGENTE) === String(formData.agenteIMOVEL))?.nomeAGENTE
                        }
                        : null}
                      onChange={option => handleChange({ target: { name: 'agenteIMOVEL', value: option?.value || '' } })}
                      placeholder="Selecione o agente..."
                      isClearable
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          borderColor: state.isFocused ? '#34574A' : '#e2e8f0',
                          boxShadow: state.isFocused ? '0 0 0 3px rgba(52, 87, 74, 0.1)' : undefined,
                          minHeight: 48,
                          fontSize: 16
                        }),
                        option: (base, state) => ({
                          ...base,
                          background: state.isSelected ? '#34574A' : state.isFocused ? '#f0fff4' : '#fff',
                          color: state.isSelected ? '#fff' : '#2d3748',
                          fontSize: 16
                        })
                      }}
                    />
                  </InputGroup>
                </>
              )}

              <InputGroup>
                <Label htmlFor="idIMOVEL" className="required">ID do Imóvel</Label>
                <Input id="idIMOVEL" name="idIMOVEL" value={formData.idIMOVEL} onChange={handleChange} placeholder="ID único do imóvel" required />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="clienteIMOVEL">Cliente</Label>
                <Input
                  id="clienteIMOVEL"
                  name="clienteIMOVEL"
                  value={formData.clienteIMOVEL || ''}
                  readOnly
                  style={{ background: '#f7fafc', color: '#a0aec0' }}
                  placeholder="Código do cliente"
                />
              </InputGroup>

            </FormGrid>
          </FormSection>
        );

      case 2: {
        const totalFotos = Array.isArray(formData.fotos) ? formData.fotos.length : 0;
        return (
          <FormSection>
            <SectionTitle style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
              Mídias do Imóvel
              <span style={{
                background: '#EDF2F7',
                color: '#2D3748',
                borderRadius: 8,
                padding: '4px 10px',
                fontSize: 14,
                fontWeight: 600
              }}>
                {totalFotos}/{MAX_FOTOS} fotos
              </span>
            </SectionTitle>
            <PhotosGrid>
              {formData.fotos && formData.fotos.length > 0 ? (
                formData.fotos.map((foto, idx) => {
                  const inputRef = React.createRef();
                  return (
                    <PhotoUploadBox
                      draggable
                      onDragStart={() => handleDragStart(idx)}
                      onDragOver={handleDragOver}
                      onDrop={() => handleDrop(idx)}
                      key={foto.codigoFOTO || idx}
                      $preview={foto.pathFOTO}
                      className={idx === 0 ? 'main-photo' : ''}
                      style={idx === 0 ? { border: '3px solid #34574A', position: 'relative' } : {}}
                      onClick={e => {
                        if (e.target.tagName !== 'BUTTON') {
                          // Se não tem foto, abre o seletor de arquivo
                          if (!foto.pathFOTO && !foto.urlFOTO) {
                            inputRef.current && inputRef.current.click();
                          }
                        }
                      }}
                    >
                      <input
                        ref={inputRef}
                        type="file"
                        accept="image/*"
                        multiple
                        onChange={handlePhotoUpload}
                        disabled={formData.fotos.length >= MAX_FOTOS}
                      />
                      {!foto.pathFOTO && (
                        <>
                          <span className="icon">📷</span>
                          <span className="text">{idx === 0 ? 'Foto Principal' : `Foto ${idx + 1}`}</span>
                        </>
                      )}
                      {foto.pathFOTO && (
                        <>
                          {idx === 0 && (
                            <span style={{
                              position: 'absolute',
                              top: 8,
                              left: 8,
                              background: '#34574A',
                              color: 'white',
                              padding: '2px 8px',
                              borderRadius: '6px',
                              fontSize: '0.75rem',
                              zIndex: 2
                            }}>Principal</span>
                          )}
                          <button
                            className="remove"
                            onClick={e => { e.stopPropagation(); handleRemovePhoto(idx); }}
                            type="button"
                          >
                            ×
                          </button>
                        </>
                      )}
                    </PhotoUploadBox>
                  );
                })
              ) : (
                (() => {
                  const inputRef = React.createRef();
                  return (
                    <PhotoUploadBox className="main-photo" onClick={() => inputRef.current && inputRef.current.click()}>
                      <input
                        ref={inputRef}
                        type="file"
                        accept="image/*"
                        multiple
                        onChange={handlePhotoUpload}
                      />
                      <span className="icon">📷</span>
                      <span className="text">Foto Principal\nArraste ou clique para upload</span>
                    </PhotoUploadBox>
                  );
                })()
              )}
              {formData.fotos && formData.fotos.length < MAX_FOTOS && (() => {
                const inputRef = React.createRef();
                return (
                  <PhotoUploadBox onClick={() => inputRef.current && inputRef.current.click()}>
                    <input
                      ref={inputRef}
                      type="file"
                      accept="image/*"
                      multiple
                      onChange={handlePhotoUpload}
                    />
                    <span className="icon">＋</span>
                    <span className="text">Adicionar Foto</span>
                  </PhotoUploadBox>
                );
              })()}
            </PhotosGrid>

            <InputGroup className="full-width">
              <Label htmlFor="videoIMOVEL">Vídeo do Imóvel (Embed YouTube, Vimeo, etc)</Label>
              <TextArea id="videoIMOVEL" name="videoIMOVEL" value={formData.videoIMOVEL || ''} onChange={handleChange} placeholder="Cole aqui o código embed ou link do vídeo" />
            </InputGroup>
            <InputGroup className="full-width">
              <Label htmlFor="360IMOVEL">Tour 360º do Imóvel (Embed)</Label>
              <TextArea id="360IMOVEL" name="360IMOVEL" value={formData["360IMOVEL"] || ''} onChange={handleChange} placeholder="Cole aqui o código embed do tour 360º" />
            </InputGroup>
          </FormSection>
        );
      }

      case 3:
        return (
          <FormSection>
            <SectionTitle>Localização</SectionTitle>
            <FormGrid>
              <InputGroup className="full-width" style={{ position: 'relative' }}>
                <Label htmlFor="enderecoIMOVEL">Endereço</Label>
                <input
                  id="enderecoIMOVEL"
                  name="enderecoIMOVEL"
                  value={formData.enderecoIMOVEL || ''}
                  onChange={handleAddressAutocomplete}
                  placeholder="Digite o endereço e selecione na lista"
                  autoComplete="off"
                  required
                  style={{ padding: 12, border: '2px solid #e2e8f0', borderRadius: 8, fontSize: '1rem' }}
                />
                {/* Lista de sugestões */}
                {addressSuggestions.length > 0 && (
                  <div
                    style={{
                      position: 'absolute',
                      top: 'calc(100% + 6px)',
                      left: 0,
                      right: 0,
                      background: '#fff',
                      zIndex: 20,
                      border: '1px solid #e2e8f0',
                      borderRadius: 8,
                      boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                      maxHeight: 260,
                      overflowY: 'auto'
                    }}
                  >
                    {addressSuggestions.map((suggestion, idx) => (
                      <div
                        key={idx}
                        style={{ padding: 10, cursor: 'pointer' }}
                        onClick={() => handleSelectAddress(suggestion)}
                      >
                        {suggestion.description}
                      </div>
                    ))}
                  </div>
                )}
              </InputGroup>
              <InputGroup>
                <Label htmlFor="numeroIMOVEL">Número</Label>
                <Input
                  id="numeroIMOVEL"
                  name="numeroIMOVEL"
                  value={formData.numeroIMOVEL || ''}
                  onChange={handleChange}
                  required
                />
              </InputGroup>
              <InputGroup>
                <Label htmlFor="zipcodeIMOVEL">Código Postal</Label>
                <Input
                  id="zipcodeIMOVEL"
                  name="zipcodeIMOVEL"
                  value={formData.zipcodeIMOVEL || ''}
                  onChange={handleChange}
                  onBlur={async (e) => {
                    const cep = e.target.value.replace(/\D/g, '');
                    if (cep.length === 8) {
                      try {
                        const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
                        const data = await response.json();
                        if (!data.erro) {
                          setFormData(prev => ({
                            ...prev,
                            enderecoIMOVEL: data.logradouro || prev.enderecoIMOVEL,
                            cityIMOVEL: data.localidade || prev.cityIMOVEL,
                            stateIMOVEL: data.uf || prev.stateIMOVEL,
                            bairroIMOVEL: data.bairro || prev.bairroIMOVEL,
                            zipcodeIMOVEL: cep
                          }));
                        } else {
                          showToast('Código Postal não encontrado!', 'error');
                        }
                      } catch (err) {
                        showToast('Erro ao buscar Código Postal!', 'error');
                      }
                    }
                  }}
                  required
                  disabled={planoBloqueado}
                />
              </InputGroup>
              <InputGroup>
                <Label htmlFor="cidadeIMOVEL">Cidade</Label>
                <Input
                  id="cidadeIMOVEL"
                  name="cidadeIMOVEL"
                  value={formData.cidadeIMOVEL || ''}
                  onChange={handleChange}
                  required
                  disabled={planoBloqueado}
                />
              </InputGroup>
              <InputGroup>
                <Label htmlFor="estadoIMOVEL">Distrito</Label>
                <Input
                  id="estadoIMOVEL"
                  name="estadoIMOVEL"
                  value={formData.estadoIMOVEL || ''}
                  onChange={handleChange}
                  required
                  disabled={planoBloqueado}
                />
              </InputGroup>
              <InputGroup>
                <Label htmlFor="paisIMOVEL">País</Label>
                <Input
                  id="paisIMOVEL"
                  name="paisIMOVEL"
                  value={formData.paisIMOVEL || ''}
                  onChange={handleChange}
                  required
                  disabled={planoBloqueado}
                />
              </InputGroup>
              <InputGroup>
                <Label htmlFor="longitudeIMOVEL">Longitude</Label>
                <Input
                  id="longitudeIMOVEL"
                  name="longitudeIMOVEL"
                  value={formData.longitudeIMOVEL || ''}
                  onChange={handleChange}
                  required
                  disabled={planoBloqueado}
                />
              </InputGroup>
              <InputGroup>
                <Label htmlFor="latitudeIMOVEL">Latitude</Label>
                <Input
                  id="latitudeIMOVEL"
                  name="latitudeIMOVEL"
                  value={formData.latitudeIMOVEL || ''}
                  onChange={handleChange}
                  required
                  disabled={planoBloqueado}
                />
              </InputGroup>
            </FormGrid>
            {/* Mapa */}
            {formData.latitudeIMOVEL && formData.longitudeIMOVEL && (
              <div style={{ marginTop: 24 }}>
                <iframe
                  title="Mapa"
                  width="100%"
                  height="300"
                  frameBorder="0"
                  style={{ border: 0, borderRadius: 12 }}
                  src={`https://www.google.com/maps?q=${formData.latitudeIMOVEL},${formData.longitudeIMOVEL}&hl=pt-BR&z=16&output=embed`}
                  allowFullScreen
                ></iframe>
              </div>
            )}
          </FormSection>
        );

      case 4: {
        // Lista completa de comodidades alinhada ao backend (inclui opções antes ausentes)
        const jsonAmenitiesRaw = {
          fumarIMOVEL: 'Fumar',
          quadraesportivaIMOVEL: 'Quadra Esportiva',
          arcondicionadoIMOVEL: 'Ar Condicionado',
          coberturaIMOVEL: 'Cobertura',
          petsIMOVEL: 'Pets',
          wifiIMOVEL: 'Wi-Fi',
          vagasgaragemIMOVEL: 'Vagas de Garagem',
          casadebanhoIMOVEL: 'Casas de Banho',
          saunaIMOVEL: 'Sauna',
          playgroundIMOVEL: 'Playground',
          lavanderiaIMOVEL: 'Lavanderia',
          elevadorIMOVEL: 'Elevador',
          festaIMOVEL: 'Festas',
          poraoIMOVEL: 'Porão',
          portariaIMOVEL: 'Portaria',
          proximoaometroIMOVEL: 'Proximidade ao Metrô',
          academiaIMOVEL: 'Academia',
          salaodejogosIMOVEL: 'Salão de Jogos',
          tvIMOVEL: 'TV',
          aquecimentoIMOVEL: 'Aquecimento',
          cozinhaIMOVEL: 'Cozinha',
          maquinadelavarIMOVEL: 'Máquina de Lavar',
          estacionamentoIMOVEL: 'Estacionamento',
          piscinaIMOVEL: 'Piscina',
          varandaIMOVEL: 'Varanda',
          churrasqueiraIMOVEL: 'Churrasqueira',
          seguranca24hIMOVEL: 'Segurança 24h',
          vistadomarIMOVEL: 'Vista para o Mar',
          mobiliadoIMOVEL: 'Mobiliado',
          acesso_praiaIMOVEL: 'Acesso à praia',
          refrigeradorIMOVEL: 'Refrigerador',
          detectorfumacaIMOVEL: 'Detector de fumaça',
          alarmemonoxidoIMOVEL: 'Alarme de monóxido de carbono',
        };

        // Mescla as opções do JSON (neste caso, já completas)
        const mergedAmenities = [
          ...Object.entries(jsonAmenitiesRaw).map(([key, label]) => ({ key, label })),
        ];

        // Lógica para exibição condicional de campos (camas apenas em férias ou arrendar mobiliado)
        const selectedTipo = tiposImovel.find(t => String(t.codigoTIPOIMOVEL) === String(formData.tipoIMOVEL));
        const tipoSlug = selectedTipo?.slugTIPOIMOVEL;
        const isFerias = tipoSlug === 'ferias' || tipoSlug === 'vacation';
        const isArrendarMobiliado = tipoSlug === 'arrendar' && (formData['Mobiliado'] === 1);
        const showBeds = Boolean(isFerias || isArrendarMobiliado);

        // Unidade dinâmica para área
        const areaUnit = (() => {
          const raw = formData.tipometragemIMOVEL ?? formData.tipoMetragemIMOVEL ?? formData.tipoMetragem;
          const str = String(raw || '').toLowerCase();
          if (raw === 2 || raw === '2' || str.includes('ft')) return 'ft²';
          if (raw === 1 || raw === '1' || str.includes('m')) return 'm²';
          return 'm²';
        })();

        return (
          <FormSection>
            <SectionTitle>Comodidades</SectionTitle>
            <FormGrid>
              <InputGroup>
                <Label htmlFor="qtdpessoasIMOVEL">Número de pessoas</Label>
                <NumericInput
                  id="qtdpessoasIMOVEL"
                  name="qtdpessoasIMOVEL"
                  type="number"
                  value={formData.qtdpessoasIMOVEL || ''}
                  onChange={handleChange}
                  placeholder="Ex: 4"
                />
              </InputGroup>

              {showBeds && (
                <>
                  <InputGroup>
                    <Label htmlFor="solteirocamasIMOVEL">Camas de Solteiro</Label>
                    <NumericInput
                      id="solteirocamasIMOVEL"
                      name="solteirocamasIMOVEL"
                      type="number"
                      value={formData.solteirocamasIMOVEL || ''}
                      onChange={handleChange}
                      placeholder="Ex: 2"
                    />
                  </InputGroup>

                  <InputGroup>
                    <Label htmlFor="casalcamasIMOVEL">Camas de Casal</Label>
                    <NumericInput
                      id="casalcamasIMOVEL"
                      name="casalcamasIMOVEL"
                      type="number"
                      value={formData.casalcamasIMOVEL || ''}
                      onChange={handleChange}
                      placeholder="Ex: 1"
                    />
                  </InputGroup>
                </>
              )}

              <InputGroup>
                <Label htmlFor="casadebanhoIMOVEL">Casas de Banho</Label>
                <NumericInput
                  id="casadebanhoIMOVEL"
                  name="casadebanhoIMOVEL"
                  type="number"
                  value={formData.casadebanhoIMOVEL || ''}
                  onChange={handleChange}
                  placeholder="Ex: 2"
                />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="quartosIMOVEL">Quartos</Label>
                <NumericInput
                  id="quartosIMOVEL"
                  name="quartosIMOVEL"
                  type="number"
                  value={formData.quartosIMOVEL || ''}
                  onChange={handleChange}
                  placeholder="Ex: 3"
                />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="vagasgaragemIMOVEL">Garagem</Label>
                <NumericInput
                  id="vagasgaragemIMOVEL"
                  name="vagasgaragemIMOVEL"
                  type="number"
                  value={formData.vagasgaragemIMOVEL || ''}
                  onChange={handleChange}
                  placeholder="Ex: 1"
                />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="tipometragemIMOVEL">Tipo da Metragem</Label>
                <ReactSelect
                  inputId="tipometragemIMOVEL"
                  name="tipometragemIMOVEL"
                  options={[
                    { value: 'm²', label: 'm²' },
                    { value: 'ft²', label: 'ft²' }
                  ]}
                  value={[
                    { value: 'm²', label: 'm²' },
                    { value: 'ft²', label: 'ft²' }
                  ].find(opt => opt.value === formData.tipometragemIMOVEL) || null}
                  onChange={option => handleChange({ target: { name: 'tipometragemIMOVEL', value: option ? option.value : '' } })}
                  placeholder="Selecione"
                  isClearable
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      borderColor: state.isFocused ? '#34574A' : '#e2e8f0',
                      boxShadow: state.isFocused ? '0 0 0 3px rgba(52, 87, 74, 0.1)' : undefined,
                      minHeight: 48,
                      fontSize: 16
                    }),
                    option: (base, state) => ({
                      ...base,
                      background: state.isSelected ? '#34574A' : state.isFocused ? '#f0fff4' : '#fff',
                      color: state.isSelected ? '#fff' : '#2d3748',
                      fontSize: 16
                    })
                  }}
                />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="metragemIMOVEL">Área</Label>
                <NumericInput
                  id="metragemIMOVEL"
                  name="metragemIMOVEL"
                  type="number"
                  value={formData.metragemIMOVEL || ''}
                  onChange={handleChange}
                  placeholder={areaUnit === 'ft²' ? 'Ex: 1292' : 'Ex: 120'}
                />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="andaresIMOVEL">Número de Andares</Label>
                <NumericInput
                  id="andaresIMOVEL"
                  name="andaresIMOVEL"
                  type="number"
                  value={formData.andaresIMOVEL || ''}
                  onChange={handleChange}
                  placeholder="Ex: 2"
                />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="anoconstrucaoIMOVEL">Ano de Construção</Label>
                <NumericInput
                  id="anoconstrucaoIMOVEL"
                  name="anoconstrucaoIMOVEL"
                  type="number"
                  value={formData.anoconstrucaoIMOVEL || ''}
                  onChange={handleChange}
                  placeholder="Ex: 2020"
                />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="situacaoIMOVEL">Situação do Imóvel</Label>
                <ReactSelect
                  inputId="situacaoIMOVEL"
                  name="situacaoIMOVEL"
                  options={[
                    { value: 'novo', label: 'Novo' },
                    { value: 'usado', label: 'Usado' },
                    { value: 'em_construcao', label: 'Em Construção' }
                  ]}
                  value={[
                    { value: 'novo', label: 'Novo' },
                    { value: 'usado', label: 'Usado' },
                    { value: 'em_construcao', label: 'Em Construção' }
                  ].find(opt => opt.value === formData.situacaoIMOVEL) || null}
                  onChange={option => handleChange({ target: { name: 'situacaoIMOVEL', value: option ? option.value : '' } })}
                  placeholder="Selecione"
                  isClearable
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      borderColor: state.isFocused ? '#34574A' : '#e2e8f0',
                      boxShadow: state.isFocused ? '0 0 0 3px rgba(52, 87, 74, 0.1)' : undefined,
                      minHeight: 48,
                      fontSize: 16
                    }),
                    option: (base, state) => ({
                      ...base,
                      background: state.isSelected ? '#34574A' : state.isFocused ? '#f0fff4' : '#fff',
                      color: state.isSelected ? '#fff' : '#2d3748',
                      fontSize: 16
                    })
                  }}
                />
              </InputGroup>

              <InputGroup>
                <Label htmlFor="posicaosolarIMOVEL">Posição Solar</Label>
                <ReactSelect
                  inputId="posicaosolarIMOVEL"
                  name="posicaosolarIMOVEL"
                  options={[
                    { value: 'norte', label: 'Norte' },
                    { value: 'sul', label: 'Sul' },
                    { value: 'leste', label: 'Leste' },
                    { value: 'oeste', label: 'Oeste' }
                  ]}
                  value={
                    [
                      { value: 'norte', label: 'Norte' },
                      { value: 'sul', label: 'Sul' },
                      { value: 'leste', label: 'Leste' },
                      { value: 'oeste', label: 'Oeste' }
                    ].find(opt => opt.value === formData.posicaosolarIMOVEL) || null
                  }
                  onChange={option => handleChange({ target: { name: 'posicaosolarIMOVEL', value: option ? option.value : '' } })}
                  placeholder="Selecione"
                  isClearable
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      borderColor: state.isFocused ? '#34574A' : '#e2e8f0',
                      boxShadow: state.isFocused ? '0 0 0 3px rgba(52, 87, 74, 0.1)' : undefined,
                      minHeight: 48,
                      fontSize: 16
                    }),
                    option: (base, state) => ({
                      ...base,
                      background: state.isSelected ? '#34574A' : state.isFocused ? '#f0fff4' : '#fff',
                      color: state.isSelected ? '#fff' : '#2d3748',
                      fontSize: 16
                    })
                  }}
                />
              </InputGroup>
            </FormGrid>
            <AmenitiesToolbar>
              <ToolbarButton
                type="button"
                onClick={() => {
                  const updated = { ...formData };
                  mergedAmenities.forEach((amenity) => {
                    updated[amenity.key] = 1;
                  });
                  setFormData(updated);
                }}
              >
                Selecionar todos
              </ToolbarButton>
              <ToolbarButton
                type="button"
                onClick={() => {
                  const updated = { ...formData };
                  mergedAmenities.forEach((amenity) => {
                    updated[amenity.key] = 0;
                  });
                  setFormData(updated);
                }}
              >
                Limpar todos
              </ToolbarButton>
            </AmenitiesToolbar>

            <AmenitiesGrid>
              {mergedAmenities.map((amenity) => (
                <Amenity
                  key={amenity.key}
                  $checked={formData[amenity.key] === 1}
                >
                  <input
                    type="checkbox"
                    name={amenity.key}
                    checked={formData[amenity.key] === 1}
                    onChange={(e) => {
                      setFormData(prev => ({
                        ...prev,
                        [amenity.key]: e.target.checked ? 1 : 0
                      }));
                    }}
                  />
                  <span className="text">{amenity.label}</span>
                </Amenity>
              ))}
            </AmenitiesGrid>
            <SectionTitle style={{ marginTop: '32px', marginBottom: '24px', display: 'block' }}>
              Comodidades Extras
            </SectionTitle>
            <ExtrasList>
              {formData.comodidadesExtras?.map((amenity, index) => (
                <ExtraItem key={index}>
                  <span className="text">{amenity}</span>
                  <RemoveButton
                    type="button"
                    onClick={() => {
                      setFormData(prev => ({
                        ...prev,
                        comodidadesExtras: prev.comodidadesExtras.filter((_, i) => i !== index),
                      }));
                    }}
                    aria-label="Remover comodidade"
                  >
                    <FaTrash size={14} />
                  </RemoveButton>
                </ExtraItem>
              ))}
            </ExtrasList>
            <InputGroup className="full-width" style={{ marginTop: '16px' }}>
              <Label htmlFor="newAmenity">Adicionar Comodidade Extra</Label>
              <AddExtrasRow>
                <Input
                  id="newAmenity"
                  name="newAmenity"
                  value={formData.newAmenity || ''}
                  onChange={(e) => setFormData(prev => ({ ...prev, newAmenity: e.target.value }))}
                  placeholder="Digite uma comodidade extra"
                  style={{ flex: 1 }}
                />
                <AddButton
                  type="button"
                  onClick={() => {
                    if (formData.newAmenity?.trim()) {
                      setFormData(prev => ({
                        ...prev,
                        comodidadesExtras: [...(prev.comodidadesExtras || []), prev.newAmenity.trim()],
                        newAmenity: '',
                      }));
                    }
                  }}
                >
                  Adicionar
                </AddButton>
              </AddExtrasRow>
            </InputGroup>
          </FormSection>
        );
      }

      case 5: {
        // Determina o modo pelo tipo de imóvel
        const selTipo = tiposImovel.find(t => String(t.codigoTIPOIMOVEL) === String(formData.tipoIMOVEL));
        let slug = selTipo?.slugTIPOIMOVEL || '';
        const nome = (selTipo?.nomeTIPOIMOVEL || '').toLowerCase();
        const isFeriasStep5 = /^(ferias|vacation|temporada|f[ée]rias|seasonal|holiday)$/i.test(slug) || nome.includes('ferias') || nome.includes('temporada') || nome.includes('férias');
        const isArrendarStep5 = /^(arrendar|rent|aluguel|alugar)$/i.test(slug) || nome.includes('arrendar') || nome.includes('aluguel');
        const isComprarStep5 = /^(comprar|compra|buy|venda|sell)$/i.test(slug) || nome.includes('comprar') || nome.includes('venda') || (!isFeriasStep5 && !isArrendarStep5);

        // Opções contextuais para o label do valor
        const priceLabelOptions = isFeriasStep5
          ? [
            { value: 'diária', label: 'Diária' },
            { value: 'semana', label: 'Semana' },
            { value: 'mês', label: 'Mês' },
          ]
          : isArrendarStep5
            ? [
              { value: 'mês', label: 'Mês' },
              { value: 'ano', label: 'Ano' },
            ]
            : [
              { value: 'venda', label: 'Venda' },
            ];

        return (
          <FormSection>
            <SectionTitle>Regras e Preços</SectionTitle>
            <FormGrid>
              <InputGroup className="full-width">
                <Label htmlFor="valorIMOVEL" className="required">
                  Preço ({selectedCurrency || formData.moedaIMOVEL || 'EUR'})
                </Label>
                <Input
                  id="valorIMOVEL"
                  name="valorIMOVEL"
                  value={valorMoeda}
                  onChange={e => {
                    const digits = e.target.value.replace(/\D/g, '');
                    if (!digits) {
                      setValorMoeda('');
                      setFormData(prev => ({ ...prev, valorIMOVEL: '' }));
                      return;
                    }
                    const num = Number(digits) / 100;
                    const formatted = num.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                    setValorMoeda(formatted);
                    // valor digitado é na moeda escolhida e é o que será salvo (com separadores brasileiros)
                    setFormData(prev => ({ ...prev, valorIMOVEL: formatted }));
                  }}
                  placeholder={`0,00 (${selectedCurrency || formData.moedaIMOVEL || 'EUR'})`}
                  required={formData.exibirPreco}
                />
                {valorMoeda && !eurRate && (
                  <small style={{ color: '#64748b', marginTop: 4, display: 'block' }}>
                    Carregando cotação para EUR...
                  </small>
                )}
                {eurRate && valorMoeda && selectedCurrency && selectedCurrency !== 'EUR' && (
                  <small style={{ color: '#475569', marginTop: 4, display: 'block' }}>
                    {`Aproximadamente em EUR: € ${(parseMoney(valorMoeda) / eurRate).toFixed(2).replace('.', ',')}`}
                  </small>
                )}
              </InputGroup>

              <InputGroup className="full-width">
                <Label>Exibir preço ao público</Label>
                <RadioGroup>
                  <RadioLabel>
                    <RadioInput
                      type="radio"
                      name="exibirPreco"
                      value="true"
                      checked={formData.exibirPreco === true}
                      onChange={() => setFormData(prev => ({ ...prev, exibirPreco: true }))}
                    />
                    Sim
                  </RadioLabel>
                  <RadioLabel>
                    <RadioInput
                      type="radio"
                      name="exibirPreco"
                      value="false"
                      checked={formData.exibirPreco === false}
                      onChange={() => setFormData(prev => ({ ...prev, exibirPreco: false }))}
                    />
                    Não (Mostrar "Sob consulta")
                  </RadioLabel>
                </RadioGroup>
              </InputGroup>

              {!isFeriasStep5 && (
                <InputGroup className="full-width">
                  <Label htmlFor="labelvalorIMOVEL">Período</Label>
                  <ReactSelect
                    inputId="labelvalorIMOVEL"
                    name="labelvalorIMOVEL"
                    options={priceLabelOptions}
                    value={priceLabelOptions.find(o => o.value === formData.labelvalorIMOVEL) || null}
                    onChange={(option) => handleChange({ target: { name: 'labelvalorIMOVEL', value: option?.value || '' } })}
                    placeholder={isArrendarStep5 ? 'Selecione: Mês/Ano' : 'Venda'}
                    isClearable={!isComprarStep5}
                    isDisabled={isComprarStep5}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        borderColor: state.isFocused ? '#34574A' : '#e2e8f0',
                        boxShadow: state.isFocused ? '0 0 0 3px rgba(52, 87, 74, 0.1)' : undefined,
                        minHeight: 48,
                        fontSize: 16
                      }),
                      option: (base, state) => ({
                        ...base,
                        background: state.isSelected ? '#34574A' : state.isFocused ? '#f0fff4' : '#fff',
                        color: state.isSelected ? '#fff' : '#2d3748',
                        fontSize: 16
                      })
                    }}
                  />
                </InputGroup>
              )}

              {isFeriasStep5 && (
                <InputGroup>
                  <Label htmlFor="minStay">Estadia Mínima (noites)</Label>
                  <NumericInput
                    id="minStay"
                    name="minStay"
                    type="number"
                    value={formData.minStay}
                    onChange={handleChange}
                    required
                  />
                </InputGroup>
              )}

              {isFeriasStep5 && (
                <InputGroup>
                  <Label htmlFor="maxStay">Estadia Máxima (noites)</Label>
                  <NumericInput
                    id="maxStay"
                    name="maxStay"
                    type="number"
                    value={formData.maxStay}
                    onChange={handleChange}
                    required
                  />
                </InputGroup>
              )}

              {isFeriasStep5 && (
                <InputGroup>
                  <Label htmlFor="checkInTime">Horário de Check-in</Label>
                  <Input
                    id="checkInTime"
                    name="checkInTime"
                    type="time"
                    value={formData.checkInTime}
                    onChange={handleChange}
                    required
                  />
                </InputGroup>
              )}

              {isFeriasStep5 && (
                <InputGroup>
                  <Label htmlFor="checkOutTime">Horário de Check-out</Label>
                  <Input
                    id="checkOutTime"
                    name="checkOutTime"
                    type="time"
                    value={formData.checkOutTime}
                    onChange={handleChange}
                    required
                  />
                </InputGroup>
              )}

              {isFeriasStep5 && (
                <InputGroup className="full-width">
                  <Label htmlFor="cancellationPolicy">Política de Cancelamento</Label>
                  <ReactSelect
                    inputId="cancellationPolicy"
                    name="cancellationPolicy"
                    options={[
                      { value: 'flexible', label: 'Flexível (24h)' },
                      { value: 'moderate', label: 'Moderada (5 dias)' },
                      { value: 'strict', label: 'Rigorosa (7 dias)' }
                    ]}
                    value={(() => {
                      const opts = [
                        { value: 'flexible', label: 'Flexível (24h)' },
                        { value: 'moderate', label: 'Moderada (5 dias)' },
                        { value: 'strict', label: 'Rigorosa (7 dias)' }
                      ];
                      return opts.find(opt => opt.value === formData.cancellationPolicy) || null;
                    })()}
                    onChange={option => handleChange({ target: { name: 'cancellationPolicy', value: option?.value || '' } })}
                    placeholder="Selecione uma política"
                    isClearable
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        borderColor: state.isFocused ? '#34574A' : '#e2e8f0',
                        boxShadow: state.isFocused ? '0 0 0 3px rgba(52, 87, 74, 0.1)' : undefined,
                        minHeight: 48,
                        fontSize: 16
                      }),
                      option: (base, state) => ({
                        ...base,
                        background: state.isSelected ? '#34574A' : state.isFocused ? '#f0fff4' : '#fff',
                        color: state.isSelected ? '#fff' : '#2d3748',
                        fontSize: 16
                      })
                    }}
                  />
                </InputGroup>
              )}

              {isFeriasStep5 && (
                <InputGroup className="full-width">
                  <Label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <input
                      type="checkbox"
                      name="instantBooking"
                      checked={formData.instantBooking}
                      onChange={handleChange}
                    />
                    Aceitar reservas automaticamente
                    <span
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '18px',
                        height: '18px',
                        borderRadius: '50%',
                        backgroundColor: '#34574A',
                        color: '#fff',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        cursor: 'help',
                        marginLeft: '4px'
                      }}
                      title="Quando ativada, os hóspedes podem confirmar a reserva imediatamente, sem necessidade de aprovação do anfitrião. As regras de cancelamento continuam a ser as definidas na Política de Cancelamento."
                    >
                      ?
                    </span>
                  </Label>
                  <div style={{ fontSize: '13px', color: '#666', marginTop: '4px', marginLeft: '24px' }}>
                    As reservas serão confirmadas automaticamente, sem necessidade de aprovação manual do anfitrião.
                  </div>
                </InputGroup>
              )}

              {isFeriasStep5 && (
                <>
                  <InputGroup className="full-width">
                    <Label>Limpeza</Label>
                    <div style={{ display: 'flex', gap: '20px', marginTop: '8px' }}>
                      <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <input
                          type="radio"
                          name="limpezaCobrada"
                          checked={formData.limpezaCobrada === true}
                          onChange={() => handleChange({ target: { name: 'limpezaCobrada', value: true } })}
                        />
                        Sim
                      </label>
                      <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <input
                          type="radio"
                          name="limpezaCobrada"
                          checked={formData.limpezaCobrada === false}
                          onChange={() => handleChange({ target: { name: 'limpezaCobrada', value: false } })}
                        />
                        Não
                      </label>
                    </div>
                  </InputGroup>

                  {formData.limpezaCobrada && (
                    <InputGroup className="full-width">
                      <Label htmlFor="valorLimpeza" className="required">Valor da Limpeza (€)</Label>
                      <MonetaryInput
                        id="valorLimpeza"
                        name="valorLimpeza"
                        type="number"
                        step="0.01"
                        min="0"
                        value={formData.valorLimpeza}
                        onChange={handleChange}
                        placeholder="0.00"
                        required
                      />
                    </InputGroup>
                  )}
                  {!formData.limpezaCobrada && (
                    <div style={{ marginTop: '8px', color: '#666', fontSize: '14px' }}>
                      A limpeza do imóvel é gratuita.
                    </div>
                  )}
                </>
              )}

              {isFeriasStep5 && (
                <>
                  <InputGroup className="full-width">
                    <Label>Taxa de Turismo Cobrada no Local</Label>
                    <div style={{ display: 'flex', gap: '20px', marginTop: '8px' }}>
                      <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <input
                          type="radio"
                          name="taxaTurismoCobrada"
                          checked={formData.taxaTurismoCobrada === true}
                          onChange={() => handleChange({ target: { name: 'taxaTurismoCobrada', value: true } })}
                        />
                        Sim
                      </label>
                      <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <input
                          type="radio"
                          name="taxaTurismoCobrada"
                          checked={formData.taxaTurismoCobrada === false}
                          onChange={() => handleChange({ target: { name: 'taxaTurismoCobrada', value: false } })}
                        />
                        Não
                      </label>
                    </div>
                  </InputGroup>

                  {formData.taxaTurismoCobrada && (
                    <>
                      <InputGroup>
                        <Label htmlFor="valorTaxaTurismoAdulto" className="required">Valor por Adulto (€)</Label>
                        <MonetaryInput
                          id="valorTaxaTurismoAdulto"
                          name="valorTaxaTurismoAdulto"
                          type="number"
                          step="0.01"
                          min="0"
                          value={formData.valorTaxaTurismoAdulto}
                          onChange={handleChange}
                          placeholder="0.00"
                          required
                        />
                      </InputGroup>

                      <InputGroup>
                        <Label htmlFor="valorTaxaTurismoCrianca" className="required">Valor por Criança (€)</Label>
                        <MonetaryInput
                          id="valorTaxaTurismoCrianca"
                          name="valorTaxaTurismoCrianca"
                          type="number"
                          step="0.01"
                          min="0"
                          value={formData.valorTaxaTurismoCrianca}
                          onChange={handleChange}
                          placeholder="0.00"
                          required
                        />
                      </InputGroup>

                      <InputGroup>
                        <Label htmlFor="idadeMaximaCrianca" className="required">Idade Máxima para Criança</Label>
                        <Input
                          id="idadeMaximaCrianca"
                          name="idadeMaximaCrianca"
                          type="number"
                          min="0"
                          max="17"
                          value={formData.idadeMaximaCrianca}
                          onChange={handleChange}
                          placeholder="0-17"
                          required
                        />
                      </InputGroup>
                    </>
                  )}
                  {!formData.taxaTurismoCobrada && (
                    <div style={{ marginTop: '8px', color: '#666', fontSize: '14px' }}>
                      Sem cobrança de taxa de turismo.
                    </div>
                  )}
                </>
              )}
            </FormGrid>
          </FormSection>
        );
      }

      default:
        return null;
    }
  };


  // Validação dos campos obrigatórios de cada etapa
  const validateStep = (step) => {
    switch (step) {
      case 1:
        return (
          formData.tituloIMOVEL.trim() &&
          formData.pacoteIMOVEL &&
          formData.moedaIMOVEL &&
          formData.tipoIMOVEL &&
          formData.categoriaIMOVEL &&
          formData.planoIMOVEL &&
          formData.idIMOVEL.trim() &&
          formData.descricaoIMOVEL.trim() &&
          !tipoIncompativel &&
          (role === 'PARTICULAR' || (formData.imobiliariaIMOVEL && formData.agenteIMOVEL))
        );

      case 2:
        return Array.isArray(formData.fotos) && formData.fotos.length > 0;
      case 3:
        return (
          formData.enderecoIMOVEL &&
          formData.numeroIMOVEL &&
          formData.zipcodeIMOVEL &&
          formData.cityIMOVEL &&
          formData.stateIMOVEL &&
          formData.paisIMOVEL &&
          formData.longitudeIMOVEL &&
          formData.latitudeIMOVEL
        );
      case 4:
        return Array.isArray(formData.comodidadesIMOVEL) && formData.comodidadesIMOVEL.length >= 0;
      case 5: {
        const selTipo = tiposImovel.find(t => String(t.codigoTIPOIMOVEL) === String(formData.tipoIMOVEL));
        const slug = selTipo?.slugTIPOIMOVEL || '';
        const isFerias = /^(ferias|vacation)$/i.test(slug);
        const isArrendar = /^(arrendar|rent|aluguel|alugar)$/i.test(slug);
        const isComprar = /^(comprar|compra|buy|venda|sell)$/i.test(slug) || (!isFerias && !isArrendar);
        const hasValor = formData.exibirPreco ? Boolean(formData.valorIMOVEL && String(formData.valorIMOVEL).trim()) : true;
        const hasLabel = Boolean(formData.labelvalorIMOVEL && String(formData.labelvalorIMOVEL).trim());
        const hasPolicy = Boolean(formData.cancellationPolicy);
        if (isComprar) {
          // Preço + Política (label está fixo em Venda)
          return hasValor && hasLabel && hasPolicy;
        }
        if (isArrendar) {
          // Preço + Label + Política
          return hasValor && hasLabel && hasPolicy;
        }
        // Férias: exige estadias e horários, mas não label
        const basicValid = hasValor && hasPolicy &&
          Boolean(formData.minStay) &&
          Boolean(formData.maxStay) &&
          Boolean(formData.checkInTime) &&
          Boolean(formData.checkOutTime);
        if (!basicValid) return false;
        // Validar campos de limpeza e taxa de turismo
        if (formData.limpezaCobrada && !String(formData.valorLimpeza || '').trim()) return false;
        if (formData.taxaTurismoCobrada) {
          if (!String(formData.valorTaxaTurismoAdulto || '').trim()) return false;
          if (!String(formData.valorTaxaTurismoCrianca || '').trim()) return false;
          if (!String(formData.idadeMaximaCrianca || '').trim()) return false;
        }
        return true;
      }

      default:
        return true;
    }
  };

  const handleNext = () => {
    // Removido bloqueio por plano - permitir navegação livre
    if (!validateStep(currentStep)) {
      showToast('Preencha todos os campos obrigatórios antes de continuar.', 'error');
      return;
    }
    if (!completedSteps.includes(currentStep)) {
      setCompletedSteps(prev => [...prev, currentStep]);
    }
    if (currentStep < steps.length) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePrevious = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
      // Ao voltar, remove steps posteriores dos concluídos
      setCompletedSteps(prev => prev.filter(s => s < currentStep));
    }
  };

  const resetNewListingForm = () => {
    skipDraftPersistRef.current = true;
    clearDraftStorage();
    try {
      setFormData(prev => ({
        ...INITIAL_FORM_DATA,
        // mantém clienteIMOVEL se já setado a partir do token
        clienteIMOVEL: prev?.clienteIMOVEL || ''
      }));
      setCompletedSteps([]);
      setCurrentStep(1);
    } catch {
      // Ignore form reset errors
      }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;
    setIsSubmitting(true);

    if (planoBloqueado) {
      showToast(motivoBloqueio, 'error');
      setIsSubmitting(false);
      return;
    }

    // Recarrega planos para garantir dados atualizados
    let planosAtualizados = planosCheckout || [];
    try {
      const token = localStorage.getItem('auth_token');
      const response = await fetch(`${import.meta.env.VITE_URL_API}/checkouts`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'accept': 'application/json'
        }
      });
      if (response.ok) {
        const data = await response.json();
        const lista = Array.isArray(data) ? data : (data?.Registros || []);
        planosAtualizados = lista;
      }
    } catch {
      // Ignore plan fetch errors
      }

    // Verifica se o pacote ainda tem vagas disponíveis antes de submeter
    if (formData.pacoteIMOVEL) {
      const selected = planosAtualizados.find(pkg => String(pkg.codigoCHECKOUT) === String(formData.pacoteIMOVEL));
      if (selected) {
        const { disponiveis, limite, utilizados } = getPacoteContagem(selected);

        if (Number(disponiveis) <= 0) {
          const nomePlano = selected?.nomeCHECKOUT || selected?.plano?.nomePLANO || 'este plano';
          showToast(`Você já atingiu o limite de imóveis para o plano '${nomePlano}'.`, 'error');
          setIsSubmitting(false);
          return;
        }

        if (Number(utilizados) >= Number(limite)) {
          const nomePlano = selected?.nomeCHECKOUT || selected?.plano?.nomePLANO || 'este plano';
          showToast(`Você já atingiu o limite de ${limite} imóvel(is) para o plano '${nomePlano}'.`, 'error');
          setIsSubmitting(false);
          return;
        }
      }
    }

    // Se for PARTICULAR, força imobiliaria/agente = 0
    const baseData = {
      ...formData,
      // Para PARTICULAR, garantir '0' como string (evita type mismatch no backend)
      ...(role === 'PARTICULAR' ? { imobiliariaIMOVEL: '0', agenteIMOVEL: '0' } : {})
    };
    // Normaliza countryIMOVEL a partir de paisIMOVEL quando possível
    if (!baseData.countryIMOVEL && baseData.paisIMOVEL) {
      baseData.countryIMOVEL = String(baseData.paisIMOVEL);
    }
    const formDataToSend = new FormData();

    // Adiciona todos os campos do baseData, pulando undefined/null e chaves inválidas
    Object.entries(baseData).forEach(([key, value]) => {
      if (key === 'fotos') return; // Fotos tratadas abaixo
      if (typeof value === 'undefined' || value === null) return;
      // Pular chaves não padronizadas (ex.: rótulos com espaço como "Máquina de Lavar", "TV", etc.)
      // Mas permite campos importantes como pacoteIMOVEL, planoIMOVEL, etc.
      if (/[^a-zA-Z0-9_]/.test(key) && !['pacoteIMOVEL', 'planoIMOVEL'].includes(key)) return;

      // Normaliza valorIMOVEL para decimal com ponto
      if (key === 'valorIMOVEL') {
        const normalized = String(value).replace(/\./g, '').replace(',', '.');
        formDataToSend.append(key, normalized);
        return;
      }

      // Envia exibirPreco como 1 ou 0
      if (key === 'exibirPreco') {
        formDataToSend.append(key, value === true ? '1' : '0');
        return;
      }

      // Mapeia selects para códigos numéricos esperados pelo backend
      if (key === 'tipometragemIMOVEL') {
        const mapTipometragem = (v) => {
          if (v === 'm²') return 1;
          if (v === 'ft²') return 2;
          const n = Number(v);
          return Number.isFinite(n) ? n : '';
        };
        const mapped = mapTipometragem(value);
        formDataToSend.append(key, String(mapped));
        return;
      }
      if (key === 'situacaoIMOVEL') {
        const mapSit = (v) => {
          if (v === 'novo') return 1;
          if (v === 'usado') return 2;
          if (v === 'em_construcao') return 3;
          const n = Number(v);
          return Number.isFinite(n) ? n : '';
        };
        const mapped = mapSit(value);
        formDataToSend.append(key, String(mapped));
        return;
      }
      if (key === 'posicaosolarIMOVEL') {
        const mapPos = (v) => {
          if (v === 'norte') return 1;
          if (v === 'sul') return 2;
          if (v === 'leste') return 3;
          if (v === 'oeste') return 4;
          const n = Number(v);
          return Number.isFinite(n) ? n : '';
        };
        const mapped = mapPos(value);
        formDataToSend.append(key, String(mapped));
        return;
      }

      if (key === 'comodidadesIMOVEL') {
        // Une comodidades base com extras antes de serializar
        const extras = Array.isArray(baseData.comodidadesExtras) ? baseData.comodidadesExtras.filter(Boolean) : [];
        const merged = Array.isArray(value) ? [...value, ...extras] : [...extras];
        formDataToSend.append(key, JSON.stringify(merged));
      } else if (typeof value === 'object') {
        formDataToSend.append(key, JSON.stringify(value));
      } else {
        // Garante string para números/booleans (ex.: 0/1) e IDs (imobiliaria/agente)
        formDataToSend.append(key, String(value ?? ''));
      }
    });

    // Garante envio das novas comodidades booleanas (caso não existam no baseData ou venham como 0)
    ['acesso_praiaIMOVEL', 'refrigeradorIMOVEL', 'detectorfumacaIMOVEL', 'alarmemonoxidoIMOVEL'].forEach((key) => {
      if (!formDataToSend.has(key)) {
        const val = formData[key] !== undefined ? formData[key] : 0;
        formDataToSend.append(key, String(val));
      }
    });

    // Envia comodidadesExtras também em campo próprio para backend ler separadamente (além do merge no comodidadesIMOVEL)
    try {
      const extras = Array.isArray(baseData.comodidadesExtras) ? baseData.comodidadesExtras.filter(Boolean) : [];
      if (extras.length > 0) {
        formDataToSend.set('comodidadesExtras', JSON.stringify(extras));
        // fallback para backend que use campo extraIMOVEL como texto
        formDataToSend.set('extraIMOVEL', extras.join(', '));
      }
    } catch {
      // Ignore extras processing errors
      }

    // Garante envio explícito de vídeo e tour 360 (top-level e agrupado em 'midia')
    try { if (!formDataToSend.has('videoIMOVEL')) formDataToSend.append('videoIMOVEL', String(formData.videoIMOVEL || '')); } catch {
      // Ignore video field errors
      }
    try { if (!formDataToSend.has('360IMOVEL')) formDataToSend.append('360IMOVEL', String(formData["360IMOVEL"] || '')); } catch {
      // Ignore 360 field errors
      }
    try {
      const midiaPayload = {
        fotosIMOVEL: String(formData.fotosIMOVEL || ''),
        videoIMOVEL: String(formData.videoIMOVEL || ''),
        ["360IMOVEL"]: String(formData["360IMOVEL"] || '')
      };
      formDataToSend.append('midia', JSON.stringify(midiaPayload));
    } catch {
      // Ignore media payload errors
      }

    // Garantir campos obrigatórios do backend
    if (!formDataToSend.has('tituloIMOVEL')) {
      formDataToSend.append('tituloIMOVEL', formData.tituloIMOVEL || '');
    }
    if (!formDataToSend.has('destaqueIMOVEL')) {
      formDataToSend.append('destaqueIMOVEL', formData.destaqueIMOVEL !== undefined ? String(formData.destaqueIMOVEL) : 'false');
    }
    if (!formDataToSend.has('visualizacaoIMOVEL')) {
      formDataToSend.append('visualizacaoIMOVEL', formData.visualizacaoIMOVEL !== undefined ? String(formData.visualizacaoIMOVEL) : '0');
    }
    // Garante envio dos campos de camas, banheiros, quartos e garagem
    if (!formDataToSend.has('solteirocamasIMOVEL')) {
      formDataToSend.append('solteirocamasIMOVEL', formData.solteirocamasIMOVEL !== undefined && formData.solteirocamasIMOVEL !== '' ? String(formData.solteirocamasIMOVEL) : '0');
    }
    if (!formDataToSend.has('casalcamasIMOVEL')) {
      formDataToSend.append('casalcamasIMOVEL', formData.casalcamasIMOVEL !== undefined && formData.casalcamasIMOVEL !== '' ? String(formData.casalcamasIMOVEL) : '0');
    }
    if (!formDataToSend.has('casadebanhoIMOVEL')) {
      formDataToSend.append('casadebanhoIMOVEL', formData.casadebanhoIMOVEL !== undefined && formData.casadebanhoIMOVEL !== '' ? String(formData.casadebanhoIMOVEL) : '0');
    }
    if (!formDataToSend.has('quartosIMOVEL')) {
      formDataToSend.append('quartosIMOVEL', formData.quartosIMOVEL !== undefined && formData.quartosIMOVEL !== '' ? String(formData.quartosIMOVEL) : '0');
    }
    if (!formDataToSend.has('vagasgaragemIMOVEL')) {
      formDataToSend.append('vagasgaragemIMOVEL', formData.vagasgaragemIMOVEL !== undefined && formData.vagasgaragemIMOVEL !== '' ? String(formData.vagasgaragemIMOVEL) : '0');
    }
    // CAMPOS OBRIGATÓRIOS DO BACKEND (adicionados se ausentes, com valor padrão)
    const obrigatorios = {
      pacoteIMOVEL: '',
      planoIMOVEL: '',
      countryIMOVEL: '',
      metragemIMOVEL: '',
      qtdpessoasIMOVEL: '0',
      // solteirocamasIMOVEL, casalcamasIMOVEL, casadebanhoIMOVEL, quartosIMOVEL, vagasgaragemIMOVEL já tratados acima
      lavanderiaIMOVEL: '0',
      wifiIMOVEL: '0',
      closetIMOVEL: '0',
      arcondicionadoIMOVEL: '0',
      tipometragemIMOVEL: '',
      andaresIMOVEL: '',
      anoconstrucaoIMOVEL: '',
      situacaoIMOVEL: '',
      posicaosolarIMOVEL: '',
      roomIMOVEL: '',
      fumarIMOVEL: '0',
      salaodejogosIMOVEL: '0',
      portariaIMOVEL: '0',
      playgroundIMOVEL: '0',
      proximoaometroIMOVEL: '0',
      elevadorIMOVEL: '0',
      poraoIMOVEL: '0',
      quadraesportivaIMOVEL: '0',
      festaIMOVEL: '0',
      academiaIMOVEL: '0',
      saunaIMOVEL: '0',
      petsIMOVEL: '0',
      coberturaIMOVEL: '0',
      extraIMOVEL: '0',
      criancasIMOVEL: '0',
      checkinIMOVEL: '',
      checkoutIMOVEL: '',
      permanenciaminimaIMOVEL: '0',
      permanenciamaximaIMOVEL: '0',
      fotosIMOVEL: '',
      emailIMOVEL: '',
      disponivelIMOVEL: '0',
      quadrabasqueteIMOVEL: '0',
      sotaoIMOVEL: '0',
      porteiroIMOVEL: '0',
      jardimdefrenteIMOVEL: '0',
      vistadolagoIMOVEL: '0',
      vistadomarIMOVEL: '0',
      espacoprivadoIMOVEL: '0',
      adegaIMOVEL: '0',
      sprinklersIMOVEL: '0',
      floorIMOVEL: '0',
      // Campos adicionais comuns nas comodidades
      seguranca24hIMOVEL: '0',
      vistamarIMOVEL: '0',
      varandaIMOVEL: '0',
      churrasqueiraIMOVEL: '0',
      piscinaIMOVEL: '0',
      estacionamentoIMOVEL: '0',
      maquinadelavarIMOVEL: '0',
      cozinhaIMOVEL: '0',
      aquecimentoIMOVEL: '0',
      tvIMOVEL: '0',
      refrigeradorIMOVEL: '0',
      detectorfumacaIMOVEL: '0',
      alarmemonoxidoIMOVEL: '0',
      // Política de cancelamento sempre presente
      cancellationPolicy: '',
      // Holiday rental specific fields
      limpezaCobrada: '0',
      valorLimpeza: '',
      taxaTurismoCobrada: '0',
      valorTaxaTurismoAdulto: '',
      valorTaxaTurismoCrianca: '',
      idadeMaximaCrianca: ''
    };
    Object.entries(obrigatorios).forEach(([key, val]) => {
      if (!formDataToSend.has(key)) {
        formDataToSend.append(key, formData[key] !== undefined ? String(formData[key]) : String(val));
      }
    });

    // SEMPRE FORÇAR ativoIMOVEL = '1' (override caso venha vazio no form)
    try { formDataToSend.delete('ativoIMOVEL'); } catch {
      // Ignore delete errors
      }
    formDataToSend.set('ativoIMOVEL', '1');

    // SEMPRE FORÇAR moedaIMOVEL (override para garantir que seja enviado)
    const moedaSelecionada = selectedCurrency || formData.moedaIMOVEL || 'EUR';
    try { formDataToSend.delete('moedaIMOVEL'); } catch {
      // Ignore delete errors
      }
    formDataToSend.set('moedaIMOVEL', moedaSelecionada);

    // Fotos: converte base64 para arquivos e envia como 'files[]'
    if (Array.isArray(formData.fotos)) {
      formData.fotos.forEach((foto, idx) => {
        if (foto.pathFOTO && foto.pathFOTO.startsWith('data:image/')) {
          // Valida tamanho da imagem (limite de 5MB para evitar erro 400)
          const base64Size = Math.round(foto.pathFOTO.length * 0.75); // aproximação do tamanho em bytes
          if (base64Size > 5 * 1024 * 1024) {
            console.warn(`Imagem ${idx} muito grande (${(base64Size / 1024 / 1024).toFixed(2)}MB), será ignorada`);
            return;
          }
          
          const arr = foto.pathFOTO.split(',');
          const mime = arr[0].match(/:(.*?);/)[1];
          const bstr = atob(arr[1]);
          let n = bstr.length;
          const u8arr = new Uint8Array(n);
          while (n--) u8arr[n] = bstr.charCodeAt(n);
          const file = new File([u8arr], `foto_${idx}.${mime.split('/')[1]}`, { type: mime });
          formDataToSend.append('files[]', file);
        }
      });
    }

    try {
      const token = localStorage.getItem('auth_token');
      const response = await fetch(`${import.meta.env.VITE_URL_API}/imoveis`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'accept': 'application/json'
        },
        body: formDataToSend
      });

      if (!response.ok) {
        // Tenta extrair o texto bruto do erro para diagnosticar
        let errorMsg = `Erro ${response.status} ao salvar anúncio`;
        const respText = await response.text();

        // Log detalhado no console: status, corpo e payload enviado
        console.error('Status:', response.status);
        console.error('Body:', respText);

        try {
          const payloadLog = {};
          for (const [k, v] of formDataToSend.entries()) {
            payloadLog[k] = v instanceof File ? `File(${v.name}, ${v.type}, ${v.size}B)` : String(v);
          }
          console.error('Payload enviado:', payloadLog);
        } catch {
          // Ignore debug logging errors
        }

        // Tratamento específico para erro 400 com extração de campos inválidos
        if (response.status === 400) {
          if (respText.includes('request entity too large') || respText.includes('file too large')) {
            errorMsg = 'Imagens muito grandes. Reduza o tamanho das imagens para no máximo 5MB cada.';
          } else if (respText.includes('invalid image format')) {
            errorMsg = 'Formato de imagem inválido. Use apenas JPG, PNG ou WebP.';
          } else if (respText) {
            try {
              const data = JSON.parse(respText);
              console.error('Resposta da API:', data);
              if (data?.errors && Array.isArray(data.errors)) {
                errorMsg = data.errors.map(e => `${e.field ? e.field + ': ' : ''}${e.message}`).join(' / ');
              } else if (data?.field && data?.message) {
                errorMsg = `${data.field}: ${data.message}`;
              } else if (data?.message || data?.error) {
                errorMsg = data.message || data.error;
              } else {
                errorMsg = 'Dados inválidos no formulário. Verifique todos os campos e tente novamente.';
              }
            } catch {
              errorMsg = `${errorMsg}: ${respText.substring(0, 300)}`; // limita tamanho
            }
          } else {
            errorMsg = 'Dados inválidos no formulário. Verifique todos os campos e tente novamente.';
          }
        } else if (respText) {
          try {
            const data = JSON.parse(respText);
            if (data && (data.message || data.error)) {
              errorMsg = data.message || data.error;
            }
          } catch {
            errorMsg = `${errorMsg}: ${respText.substring(0, 300)}`; // limita tamanho
          }
        }
        showToast(errorMsg, 'error');
        setIsSubmitting(false);
        return;
      }

      // Limpa o draft e reseta formulário/etapas após sucesso
      skipDraftPersistRef.current = true;
      localStorage.removeItem(`newListingDraft:${userId}`);
      localStorage.removeItem(`newListingDraft:${userId}:fotos`);

      showToast('Anúncio publicado com sucesso!', 'success');
      // Navega imediatamente para dar feedback rápido ao usuário
      navigate('/dashboard/listings');
      // Reseta o formulário após a navegação (não bloqueia a UI)
      setTimeout(() => resetNewListingForm(), 100);
    } catch (error) {
      showToast(error.message || 'Erro ao salvar anúncio', 'error');
      setIsSubmitting(false);
    }
  };

  return (
    <PageContainer>
      <Container>
        <Sidebar>
          <ProgressSteps
            steps={steps}
            currentStep={currentStep}
            completedSteps={completedSteps}
            onStepClick={goToStep}
          />
        </Sidebar>

        <MainContent>
          <Header>
            <div>
              <Title>Novo Anúncio</Title>
              <Subtitle>Etapa {currentStep}: {steps.find(s => s.number === currentStep)?.text}</Subtitle>
            </div>
            <EyeButton title="Pré-visualizar anúncio" onClick={() => setShowPreview(true)}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                <circle cx="12" cy="12" r="3" />
              </svg>
            </EyeButton>
          </Header>

          {draftRestored && (
            <div style={{
              background: '#f0fff4',
              border: '1px solid #86efac',
              borderRadius: 8,
              padding: '12px 16px',
              margin: '16px 32px 0',
              color: '#166534',
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
              Rascunho restaurado com sucesso.
            </div>
          )}

          <form
            onSubmit={(e) => {
              e.preventDefault();
              if (currentStep < steps.length) {
                // Em etapas intermediárias, avançar ao invés de submeter
                try { handleNext && handleNext(); } catch {
                  try { goToStep(currentStep + 1); } catch {
                    // Ignore navigation errors
                    }
                  }
              } else {
                // Somente na última etapa efetua o POST
                handleSubmit(e);
              }
            }}
            onKeyDown={(e) => {
              // Evita submit com Enter nas etapas intermediárias (permite em textarea)
              if (e.key === 'Enter' && e.target && e.target.tagName !== 'TEXTAREA' && currentStep < steps.length) {
                e.preventDefault();
              }
            }}
          >
            <StepContent>
              {renderStepContent()}
            </StepContent>

            <NavigationButtons>
              <div style={{ display: 'flex', gap: 12 }}>
                <Button type="button" className="secondary danger" onClick={handleCancel}>
                  Cancelar anúncio
                </Button>
                {currentStep > 1 && (
                  <Button type="button" className="secondary" onClick={handlePrevious}>
                    Voltar
                  </Button>
                )}
              </div>

              <div style={{ display: 'flex', gap: 12 }}>
                {currentStep < steps.length ? (
                  <Button type="button" onClick={handleNext}>
                    Próximo
                  </Button>
                ) : (
                  <Button type="submit" className="primary" disabled={isSubmitting}>
                    {isSubmitting ? 'Publicando...' : 'Publicar Anúncio'}
                  </Button>
                )}
              </div>
            </NavigationButtons>
          </form>
        </MainContent>
      </Container>
      {showPreview && (
        <PreviewModalOverlay onClick={() => setShowPreview(false)}>
          <PreviewModalBox onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <h3>Pré-visualização do Anúncio</h3>
              <CloseModal type="button" onClick={() => setShowPreview(false)}>Fechar</CloseModal>
            </ModalHeader>
            <ModalBody>
              {(() => {
                const fotos = Array.isArray(formData.fotos) ? formData.fotos : [];
                if (fotos.length === 0) return null;
                const primary = fotos.find(f => f.padraoFOTO === 1) || fotos[0];
                const rest = fotos.filter(f => f !== primary);
                const thumbs = rest.slice(0, 4);
                return (
                  <HeroGrid>
                    <HeroMain
                      $image={primary.pathFOTO || primary.urlFOTO}
                      onClick={() => { setLightboxIndex(0); setShowLightbox(true); }}
                      role="button"
                    />
                    <RightMosaic>
                      {thumbs.map((f, i) => (
                        <HeroThumb
                          key={f.codigoFOTO || i}
                          $image={f.pathFOTO || f.urlFOTO}
                          onClick={() => { setLightboxIndex(i + 1); setShowLightbox(true); }}
                          role="button"
                        >
                          {i === 1 && (
                            <ViewAllButton type="button" onClick={(e) => { e.stopPropagation(); setLightboxIndex(0); setShowLightbox(true); }}>Ver todas as fotos</ViewAllButton>
                          )}
                        </HeroThumb>
                      ))}
                      {thumbs.length < 4 && Array.from({ length: 4 - thumbs.length }).map((_, idx) => (
                        <HeroThumb key={`ph-${idx}`} />
                      ))}
                    </RightMosaic>
                  </HeroGrid>
                );
              })()}
              <ContentContainer>
                <ActionBar>
                  <LeftGroup>
                    <TopRow>
                      <BackLink onClick={() => setShowPreview(false)}>
                        <FaArrowLeft /> VOLTAR
                      </BackLink>
                      {(() => {
                        const tipoSel = tiposImovel.find(t => String(t.codigoTIPOIMOVEL) === String(formData.tipoIMOVEL));
                        const slug = (tipoSel?.slugTIPOIMOVEL || '').toLowerCase();
                        if (!slug) return null;
                        const label = slug === 'comprar' ? 'Vender' : tipoSel?.nomeTIPOIMOVEL || slug;
                        return (
                          <span style={{ marginLeft: 8, padding: '4px 10px', borderRadius: 999, background: '#eef2ff', color: '#4338ca', fontWeight: 700, fontSize: 12 }}>
                            {label}
                          </span>
                        );
                      })()}
                      {String(formData.destaqueIMOVEL) === 'true' || formData.destaqueIMOVEL === true ? (
                        <Badge>DESTAQUE</Badge>
                      ) : null}
                    </TopRow>
                    <TitleStatus>
                      {formData.disponivelIMOVEL === '0' || formData.disponivelIMOVEL === 0 ? 'Imóvel indisponível no momento' : (formData.tituloIMOVEL || 'Título do Anúncio')}
                    </TitleStatus>
                    <LocationText>
                      <FaMapMarkerAlt />
                      <span>{formData.enderecoIMOVEL || 'Endereço não informado'}</span>
                      <span style={{ margin: '0 6px' }}>•</span>
                      <span>{formData.cityIMOVEL || formData.cidadeIMOVEL || formData.city || 'Cidade não informada'}</span>
                    </LocationText>
                  </LeftGroup>
                  <RightGroup>
                    <GhostButton><FaHeart style={{ color: '#BA824F' }} /> Favorito</GhostButton>
                    <GhostButton><FaShare style={{ color: '#6b7280' }} /> Compartilhar</GhostButton>
                  </RightGroup>
                </ActionBar>
                <ModalGrid>
                  <SideInfo>
                      {(() => {
                        const areaUnit = (() => {
                          const raw = formData.tipometragemIMOVEL ?? formData.tipoMetragemIMOVEL ?? formData.tipoMetragem;
                          const str = String(raw || '').toLowerCase();
                          if (raw === 2 || raw === '2' || str.includes('ft')) return 'ft²';
                          if (raw === 1 || raw === '1' || str.includes('m')) return 'm²';
                          return 'm²';
                        })();
                        const boolToSim = (v) => (v === 1 || v === '1' || v === true || (typeof v === 'string' && v.toLowerCase() === 'true')) ? 'Sim' : '';
                        const items = [
                          { icon: <FaUser />, label: 'NÚMERO DE PESSOAS', value: formData.qtdpessoasIMOVEL },
                          { icon: <FaBed />, label: 'CAMAS DE SOLTEIRO', value: formData.solteirocamasIMOVEL },
                          { icon: <FaBed />, label: 'CAMAS DE CASAL', value: formData.casalcamasIMOVEL },
                          { icon: <FaBath />, label: 'CASAS DE BANHO', value: formData.casadebanhoIMOVEL },
                          { icon: <FaBed />, label: 'QUARTOS', value: formData.quartosIMOVEL },
                          { icon: <FaParking />, label: 'GARAGEM', value: formData.vagasgaragemIMOVEL },
                          { icon: <FaRuler />, label: 'TIPO DA METRAGEM', value: formData.tipoMetragemIMOVEL || formData.tipoMetragem || formData.tipometragemIMOVEL },
                          { icon: <FaRuler />, label: `ÁREA (${areaUnit || 'm²'})`, value: formData.metragemIMOVEL ? `${formData.metragemIMOVEL} ${areaUnit || ''}`.trim() : '' },
                          { icon: <FaRuler />, label: 'ÁREA (FT)', value: formData.areaFTIMOVEL || formData.areaFT },
                          { icon: <FaHome />, label: 'NÚMERO DE ANDARES', value: formData.numerodeandaresIMOVEL || formData.andaresIMOVEL || formData.andares },
                          { icon: <FaHome />, label: 'ANO DE CONSTRUÇÃO', value: formData.anoconstrucaoIMOVEL || formData.anoConstrucao },
                          { icon: <FaHome />, label: 'SITUAÇÃO DO IMÓVEL', value: formData.situacaoIMOVEL },
                          { icon: <FaHome />, label: 'NOVO', value: boolToSim(formData.novoIMOVEL) },
                          { icon: <FaHome />, label: 'POSIÇÃO SOLAR', value: formData.posicaosolarIMOVEL || formData.posicaoSolar },
                        ].filter(it => it.value !== undefined && it.value !== null && String(it.value).trim() !== '' && String(it.value) !== '0');
                        if (items.length === 0) return null;
                        return (
                          <SectionCard>
                            <PillTitle>Características</PillTitle>
                            <FactsGrid>
                              {items.map((it, idx) => (
                                <FactItem key={idx}>
                                  <span style={{ color: '#64748b' }}>{it.icon}</span>
                                  <div>
                                    <div className="label">{it.label}</div>
                                    <div className="value">{it.value}</div>
                                  </div>
                                </FactItem>
                              ))}
                            </FactsGrid>
                          </SectionCard>
                        );
                      })()}

                  {(() => {
                    // Mapa abrangente de *_IMOVEL -> rótulo amigável
                    const amenitiesMap = {
                      fumarIMOVEL: 'Fumar',
                      quadraesportivaIMOVEL: 'Quadra Esportiva',
                      arcondicionadoIMOVEL: 'Ar Condicionado',
                      coberturaIMOVEL: 'Cobertura',
                      petsIMOVEL: 'Pets',
                      wifiIMOVEL: 'Wi-Fi',
                      vagasgaragemIMOVEL: 'Vagas de Garagem',
                      casadebanhoIMOVEL: 'Casas de Banho',
                      saunaIMOVEL: 'Sauna',
                      playgroundIMOVEL: 'Playground',
                      lavanderiaIMOVEL: 'Lavanderia',
                      elevadorIMOVEL: 'Elevador',
                      festaIMOVEL: 'Festas',
                      poraoIMOVEL: 'Porão',
                      portariaIMOVEL: 'Portaria',
                      proximoaometroIMOVEL: 'Proximidade ao Metrô',
                      academiaIMOVEL: 'Academia',
                      salaodejogosIMOVEL: 'Salão de Jogos',
                      tvIMOVEL: 'TV',
                      aquecimentoIMOVEL: 'Aquecimento',
                      cozinhaIMOVEL: 'Cozinha',
                      maquinadelavarIMOVEL: 'Máquina de Lavar',
                      estacionamentoIMOVEL: 'Estacionamento incluído',
                      piscinaIMOVEL: 'Piscina',
                      varandaIMOVEL: 'Varanda',
                      churrasqueiraIMOVEL: 'Churrasqueira',
                      seguranca24hIMOVEL: 'Segurança 24h',
                      vistadomarIMOVEL: 'Vista para o Mar',
                      mobiliadoIMOVEL: 'Mobiliado',
                      acesso_praiaIMOVEL: 'Acesso à praia',
                      refrigeradorIMOVEL: 'Refrigerador',
                      detectorfumacaIMOVEL: 'Detector de fumaça',
                      alarmemonoxidoIMOVEL: 'Alarme de monóxido de carbono',
                    };

                    const isChecked = (val) => {
                      if (val === 1 || val === '1' || val === true) return true;
                      if (typeof val === 'string') {
                        const v = val.trim().toLowerCase();
                        if (v === 'true' || v === 'on' || v === 'yes' || v === 'sim') return true;
                      }
                      return false;
                    };

                    const labelFromKey = (key) => {
                      if (amenitiesMap[key]) return amenitiesMap[key];
                      // Formata chaves desconhecidas *_IMOVEL => Rótulo Capitalizado
                      const base = key.replace(/IMOVEL$/i, '')
                        .replace(/_/g, ' ')
                        .replace(/([a-z])([A-Z])/g, '$1 $2')
                        .trim();
                      if (!base) return '';
                      return base.charAt(0).toUpperCase() + base.slice(1);
                    };

                    // Coleta de todas as fontes: qualquer chave booleana do formData, arrays e extras
                    const selectedLabels = new Set();
                    Object.entries(formData || {}).forEach(([key, val]) => {
                      if (!isChecked(val)) return;
                      if (typeof key !== 'string') return;
                      if (amenitiesMap[key]) {
                        selectedLabels.add(amenitiesMap[key]);
                      } else if (/IMOVEL$/i.test(key)) {
                        const label = labelFromKey(key);
                        if (label) selectedLabels.add(label);
                      } else {
                        // rótulos diretos, ex.: 'Wi-Fi', 'TV'
                        selectedLabels.add(key);
                      }
                    });

                    const arr = Array.isArray(formData.comodidadesIMOVEL) ? formData.comodidadesIMOVEL : [];
                    arr.forEach(v => {
                      if (!v) return;
                      const s = String(v).trim();
                      if (amenitiesMap[s]) selectedLabels.add(amenitiesMap[s]);
                      else if (amenitiesMap[s + 'IMOVEL']) selectedLabels.add(amenitiesMap[s + 'IMOVEL']);
                      else selectedLabels.add(s);
                    });

                    // Lista que iremos exibir com ícones
                    const allIcons = {
                      'Acesso à praia': <FaWater className="icon" />,
                      'Wi-Fi': <FaWifi className="icon" />,
                      'TV': <FaTv className="icon" />,
                      'Máquina de Lavar': <FaSnowflake className="icon" />, // ícone aproximado
                      'Máquina de lavar': <FaSnowflake className="icon" />, // tolerância de label
                      'Cozinha': <FaUtensils className="icon" />,
                      'Estacionamento incluído': <FaCar className="icon" />,
                      'Estacionamento': <FaCar className="icon" />,
                      'Elevador': <FaArrowsAltV className="icon" />,
                      'Refrigerador': <FaSnowflake className="icon" />,
                      'Detector de fumaça': <FaSmokingBan className="icon" />, // ícone aproximado
                      'Alarme de monóxido de carbono': <FaBellSlash className="icon" />, // ícone aproximado
                      'Piscina': <FaWater className="icon" />,
                      'Varanda': <FaHome className="icon" />,
                      'Churrasqueira': <FaUtensils className="icon" />,
                      'Ar Condicionado': <FaSnowflake className="icon" />,
                      'Academia': <FaHome className="icon" />,
                      'Casas de Banho': <FaBath className="icon" />,
                      'Cobertura': <FaHome className="icon" />,
                      'Festas': <FaHome className="icon" />,
                      'Fumar': <FaSmokingBan className="icon" />,
                      'Pets': <FaHome className="icon" />,
                      'Playground': <FaHome className="icon" />,
                      'Portaria': <FaHome className="icon" />,
                      'Quadra Esportiva': <FaHome className="icon" />,
                      'Sauna': <FaHome className="icon" />,
                      'Vagas de Garagem': <FaParking className="icon" />,
                      'Vista para o Mar': <FaWater className="icon" />,
                      'Mobiliado': <FaHome className="icon" />,
                      'Lavanderia': <FaHome className="icon" />,
                      'Porão': <FaHome className="icon" />,
                      'Proximidade ao Metrô': <FaHome className="icon" />,
                      'Salão de Jogos': <FaHome className="icon" />,
                      'Segurança 24h': <FaHome className="icon" />,
                    };

                    // Separa comodidades base (com ícones) de extras (sem ícones)
                    let baseList = Array.from(selectedLabels);
                    baseList.sort((a, b) => a.localeCompare(b, 'pt-BR'));
                    const extras = Array.isArray(formData.comodidadesExtras) ? formData.comodidadesExtras.filter(Boolean) : [];
                    const extrasSet = new Set(extras);
                    const extrasSorted = [...extras].sort((a, b) => a.localeCompare(b, 'pt-BR'));

                    if (baseList.length === 0 && extrasSorted.length === 0) return null;

                    const initialCount = 10;
                    const baseToShow = amenitiesExpanded ? baseList : baseList.slice(0, Math.min(initialCount, baseList.length));
                    const baseTotal = baseList.length;
                    const extrasToShow = extrasExpanded ? extrasSorted : extrasSorted.slice(0, Math.min(initialCount, extrasSorted.length));
                    const extrasTotal = extrasSorted.length;

                    return (
                      <SectionCard>
                        <PillTitle>Comodidades</PillTitle>
                        <AmenitiesList>
                          {baseToShow.map((label, idx) => (
                            <AmenityRow key={`row-${idx}`}>
                              {extrasSet.has(label)
                                ? <span style={{ width: 24, height: 24 }} />
                                : (allIcons[label] || <FaHome className="icon" />)
                              }
                              <div>{label}</div>
                            </AmenityRow>
                          ))}
                        </AmenitiesList>
                        {(!amenitiesExpanded && baseTotal > baseToShow.length) && (
                          <div style={{ marginTop: 14 }}>
                            <button type="button" onClick={() => setAmenitiesExpanded(true)} style={{ padding: '10px 14px', background: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: 10, fontWeight: 700, color: '#111827' }}>
                              {`Mostrar todas as ${baseTotal} comodidades`}
                            </button>
                          </div>
                        )}

                        {extrasSorted.length > 0 && (
                          <div style={{ marginTop: 18 }}>
                            <div style={{ fontWeight: 700, fontSize: 13, color: '#374151', margin: '0 0 8px' }}>Comodidades Extras</div>
                            <AmenitiesList>
                              {extrasToShow.map((label, idx) => (
                                <AmenityRow key={`extra-${idx}`}>
                                  <span style={{ width: 24, height: 24 }} />
                                  <div>{label}</div>
                                </AmenityRow>
                              ))}
                            </AmenitiesList>
                            {(!extrasExpanded && extrasTotal > extrasToShow.length) && (
                              <div style={{ marginTop: 10 }}>
                                <button type="button" onClick={() => setExtrasExpanded(true)} style={{ padding: '10px 14px', background: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: 10, fontWeight: 700, color: '#111827' }}>
                                  {`Mostrar todas as ${extrasTotal} comodidades extras`}
                                </button>
                              </div>
                            )}
                          </div>
                        )}
                      </SectionCard>
                    );
                  })()}

                      {formData.descricaoIMOVEL && (() => {
                        const full = String(formData.descricaoIMOVEL || '');
                        const limit = 320;
                        const collapsed = full.length > limit ? (full.slice(0, limit).trimEnd() + '…') : full;
                        const shouldCollapse = full.length > limit;
                        return (
                          <SectionCard>
                            <PillTitle>Descrição</PillTitle>
                            <div style={{ fontSize: 15, color: '#4a5568', lineHeight: 1.7, whiteSpace: 'pre-line', wordBreak: 'break-word' }}>
                              {descriptionExpanded ? full : collapsed}
                            </div>
                            {shouldCollapse && !descriptionExpanded && (
                              <div style={{ marginTop: 10 }}>
                                <button type="button" onClick={() => setDescriptionExpanded(true)} style={{ padding: '8px 12px', background: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: 10, fontWeight: 700, color: '#111827' }}>
                                  Mostrar tudo
                                </button>
                              </div>
                            )}
                          </SectionCard>
                        );
                      })()}

                      {formData.regrasadicionaisIMOVEL && (
                        <SectionCard>
                          <PillTitle>Regras Adicionais</PillTitle>
                          <div style={{ fontSize: 15, color: '#4a5568', lineHeight: 1.7, whiteSpace: 'pre-line', wordBreak: 'break-word' }}>
                            {formData.regrasadicionaisIMOVEL}
                          </div>
                        </SectionCard>
                      )}

                      {/* Removido 'Detalhes Adicionais': itens agora fazem parte de 'Características' para evitar duplicações */}

                  

                  

                  {formData.videoIMOVEL && (
                    <SectionCard>
                      <PillTitle>Vídeo Informativo</PillTitle>
                      <div style={{ borderRadius: 12, overflow: 'hidden', border: '1px solid #e5e7eb' }}>
                        <iframe
                          width="100%"
                          height="315"
                          src={(() => {
                            let input = formData.videoIMOVEL || '';
                            // If user pasted full <iframe ...>, extract the src value
                            if (/<iframe/i.test(input)) {
                              const m = input.match(/src\s*=\s*"([^"]+)"|src\s*=\s*'([^']+)'/i);
                              input = m ? (m[1] || m[2] || '') : '';
                            }
                            // Normalize common YouTube link to embed
                            if (/youtube\.com|youtu\.be/.test(input)) {
                              input = input.replace('watch?v=', 'embed/');
                            }
                            // Only allow http(s) absolute URLs
                            if (!/^https?:\/\//i.test(input)) return '';
                            return input;
                          })()}
                          title="Vídeo do imóvel"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          referrerPolicy="strict-origin-when-cross-origin"
                          allowFullScreen
                        />
                      </div>
                    </SectionCard>
                  )}

                  {formData["360IMOVEL"] && (
                    <SectionCard>
                      <PillTitle>Tour Virtual 3D</PillTitle>
                      <div style={{ borderRadius: 12, overflow: 'hidden', border: '1px solid #e5e7eb' }}>
                        <iframe
                          src={(() => {
                            let input = String(formData["360IMOVEL"]) || '';
                            // If user pasted full <iframe ...>, extract the src value
                            if (/<iframe/i.test(input)) {
                              const m = input.match(/src\s*=\s*"([^"]+)"|src\s*=\s*'([^']+)'/i);
                              input = m ? (m[1] || m[2] || '') : '';
                            }
                            // Only allow http(s) absolute URLs
                            if (!/^https?:\/\//i.test(input)) return '';
                            return input;
                          })()}
                          width="100%"
                          height="360"
                          allowFullScreen
                          style={{ border: 0 }}
                          title="Tour 3D"
                        />
                      </div>
                    </SectionCard>
                  )}

                  {((formData.enderecoIMOVEL && formData.enderecoIMOVEL.trim() !== '') || (formData.latitudeIMOVEL && formData.longitudeIMOVEL)) && (
                    <SectionCard>
                      <PillTitle>Localização</PillTitle>
                      <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                        <button disabled style={{ padding: '6px 10px', border: '1px solid #e5e7eb', borderRadius: 999, background: '#111', color: '#fff', fontWeight: 700, fontSize: 12 }}>Mapa</button>
                        <button disabled style={{ padding: '6px 10px', border: '1px solid #e5e7eb', borderRadius: 999, background: '#fff', color: '#4b5563', fontWeight: 700, fontSize: 12 }}>Satélite</button>
                      </div>
                      <div style={{ borderRadius: 12, overflow: 'hidden', border: '1px solid #e5e7eb', height: 300 }}>
                        <iframe
                          title="Mapa do Imóvel"
                          src={(formData.latitudeIMOVEL && formData.longitudeIMOVEL)
                            ? `https://maps.google.com/maps?q=${formData.latitudeIMOVEL},${formData.longitudeIMOVEL}&z=15&output=embed`
                            : 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3673.4847274039365!2d-45.5944444!3d-22.7444444!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjLCsDQ0JzQwLjAiUyA0NcKwMzUnNDAuMCJX!5e0!3m2!1spt-BR!2sbr!4v1625097752726!5m2!1spt-BR!2sbr'}
                          width="100%"
                          height="100%"
                          style={{ border: 0 }}
                          loading="lazy"
                          referrerPolicy="no-referrer-when-downgrade"
                        />
                      </div>
                    </SectionCard>
                  )}
                </SideInfo>
                <BookingBox>
                  {(() => {
                    const iso = selectedCurrency || formData.moedaIMOVEL || 'EUR';
                    const symbol = getCurrencySymbol(iso) || iso;
                    const valorNum = parseMoney(formData.valorIMOVEL);
                    const valorFormatado = Number.isFinite(valorNum) && valorNum > 0
                      ? `${symbol} ${valorNum.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                      : `${symbol} —`;
                    const tipoSel = tiposImovel.find(t => String(t.codigoTIPOIMOVEL) === String(formData.tipoIMOVEL));
                    const tipoSlug = (tipoSel?.slugTIPOIMOVEL || '').toLowerCase();
                    const isFeriasPreview = /^(ferias|vacation)$/i.test(tipoSlug);
                    return (
                      <div style={{ background: '#111', color: '#fff', borderRadius: 8, padding: '10px 12px', display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' }}>
                        <span style={{ fontSize: 22, fontWeight: 800 }}>
                          {valorFormatado}
                        </span>
                        {!/^(comprar|compra|buy|venda|sell)$/i.test(tipoSlug) && (
                          <span style={{ fontSize: 12, opacity: .9 }}>por {formData.labelvalorIMOVEL || (isFeriasPreview ? 'noite' : 'mês')}</span>
                        )}
                      </div>
                    );
                  })()}
                  {(() => {
                    const tipoSel = tiposImovel.find(t => String(t.codigoTIPOIMOVEL) === String(formData.tipoIMOVEL));
                    const tipoSlug = (tipoSel?.slugTIPOIMOVEL || '').toLowerCase();
                    const isFeriasPreview = /^(ferias|vacation)$/i.test(tipoSlug);
                    const isComprarPreview = /^(comprar|compra|buy|venda|sell)$/i.test(tipoSlug);
                    if (!isFeriasPreview || isComprarPreview) return null;
                    return (
                      <>
                        <div style={{ background: '#fff', border: '1px solid #f1f5f9', borderRadius: 12, padding: 12, marginTop: 12 }}>
                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                            <input disabled placeholder="dd/mm/aaaa" style={{ padding: 10, border: '1px solid #e5e7eb', borderRadius: 10 }} />
                            <input disabled placeholder="dd/mm/aaaa" style={{ padding: 10, border: '1px solid #e5e7eb', borderRadius: 10 }} />
                          </div>
                          <div style={{ marginTop: 8 }}>
                            <input disabled placeholder="N.º de hóspedes" style={{ width: '100%', padding: 10, border: '1px solid #e5e7eb', borderRadius: 10 }} />
                          </div>
                          <div style={{ marginTop: 8 }}>
                            <textarea disabled placeholder="Apresente-se ao anfitrião" rows={4} style={{ width: '100%', padding: 10, border: '1px solid #e5e7eb', borderRadius: 10 }} />
                          </div>
                          <div style={{ color: '#6b7280', fontSize: 13, lineHeight: 1.6, marginTop: 6 }}>
                            Dê uma breve apresentação, horários aproximados de check-in e qualquer informação que ajude o anfitrião a recebê-lo melhor.
                          </div>
                        </div>
                        <button disabled style={{ width: '100%', marginTop: 12, background: '#BA824F', color: '#fff', border: 'none', padding: '12px 16px', borderRadius: 8, fontWeight: 700 }}>
                          Solicitar Reserva
                        </button>
                      </>
                    );
                  })()}
                  <SideAction disabled style={{ marginTop: 10 }}>
                    <FaHeart style={{ color: '#BA824F' }} /> Favorito
                  </SideAction>
                  <SideButton disabled style={{ marginTop: 10 }}>
                    Contactar o anfitrião
                  </SideButton>
                  <SideButton disabled style={{ marginTop: 8 }}>
                    <FaWhatsapp style={{ color: '#22c55e' }} /> WhatsApp do anfitrião
                  </SideButton>
                  <SideButton disabled style={{ marginTop: 8 }}>
                    <FaShare /> Compartilhar
                  </SideButton>

                  {(() => {
                    const hostName = (currentUser && (
                      currentUser.nome ||
                      currentUser.nomeUSUARIO ||
                      currentUser.name ||
                      currentUser.fullName ||
                      currentUser.username ||
                      currentUser.email
                    )) || 'Anfitrião';
                    const agency = (currentUser && (
                      currentUser?.imobiliaria?.nomeIMOBILIARIA ||
                      currentUser?.nomeIMOBILIARIA ||
                      currentUser?.imobiliaria ||
                      currentUser?.agencia ||
                      currentUser?.agency
                    )) || 'Indisponível';
                    const workplace = (currentUser && (
                      currentUser.localTrabalho ||
                      currentUser.workplace ||
                      currentUser.empresa ||
                      currentUser.company
                    )) || '—';

                    const hostInfo = currentUser?.imobiliaria?.host || currentUser?.host || {};
                    const hostTipo = (hostInfo.tipo || '').toLowerCase();
                    const selo = !!hostInfo.selo || hostTipo === 'superhost';
                    const hostLabel = hostTipo === 'superhost'
                      ? 'Superhost'
                      : hostTipo === 'gestao_profissional'
                        ? 'Gestão Profissional'
                        : 'Host';

                    const reviewsData = currentUser?.imobiliaria?.reviews || currentUser?.reviews || {};
                    const totalReviews = Number(reviewsData.total || 0);
                    const mediaReviews = Number(reviewsData.media || 0);
                    const renderStars = (rating) => {
                      const full = Math.round(Math.min(5, Math.max(0, rating)));
                      return '★★★★★'.slice(0, full).padEnd(5, '☆');
                    };

                    return (
                      <HostCard>
                        <div className="avatar">
                          <img alt="Host" src={`https://ui-avatars.com/api/?name=${encodeURIComponent(hostName)}&background=BA824F&color=fff&format=svg`} width="88" height="88" />
                        </div>
                        <div className="name">{hostName}</div>
                        <div className="role" style={{ display: 'flex', alignItems: 'center', gap: 6, justifyContent: 'center' }}>
                          <span>{hostLabel}</span>
                          {selo && (
                            <span style={{ background: '#BA824F', color: '#fff', padding: '2px 8px', borderRadius: 999, fontSize: 12, fontWeight: 700 }}>Selo</span>
                          )}
                        </div>
                        <div className="line">Imobiliária: {agency}</div>
                        <div className="line">Local de trabalho: {workplace}</div>
                        <div className="rating">
                          <span>{renderStars(mediaReviews)}</span>{' '}
                          <span style={{ color: '#111827' }}>{mediaReviews.toFixed(1)}</span>{' '}
                          <span style={{ color: '#6b7280' }}>({totalReviews} reviews)</span>
                        </div>
                      </HostCard>
                    );
                  })()}
                </BookingBox>
              </ModalGrid>
            </ContentContainer>
          </ModalBody>
        </PreviewModalBox>
        </PreviewModalOverlay>
      )}

      {showLightbox && (() => {
        const fotos = Array.isArray(formData.fotos) ? formData.fotos : [];
        if (fotos.length === 0) return null;
        const primary = fotos.find(f => f.padraoFOTO === 1) || fotos[0];
        const rest = fotos.filter(f => f !== primary);
        const ordered = [primary, ...rest];
        const total = ordered.length;
        const idx = Math.min(lightboxIndex, total - 1);
        const current = ordered[idx];
        const src = current ? (current.pathFOTO || current.urlFOTO) : '';
        const goPrev = () => setLightboxIndex((idx - 1 + total) % total);
        const goNext = () => setLightboxIndex((idx + 1) % total);
        return (
          <LightboxOverlay onClick={() => setShowLightbox(false)}>
            <LightboxImage $image={src} onClick={(e) => e.stopPropagation()} />
            <LightboxNav $left onClick={(e) => { e.stopPropagation(); goPrev(); }}>{'‹'}</LightboxNav>
            <LightboxNav onClick={(e) => { e.stopPropagation(); goNext(); }}>{'›'}</LightboxNav>
            <LightboxClose onClick={(e) => { e.stopPropagation(); setShowLightbox(false); }} aria-label="Fechar visualização">×</LightboxClose>
          </LightboxOverlay>
        );
      })()}

      {toast.open && (
        <Toast type={toast.type}>
          {toast.type === 'success' ? '✔️' : '❌'}
          <span>{toast.message}</span>
        </Toast>
      )}
    </PageContainer>
  );
};
export { Label, Input, TextArea };
export default NewProperty;